const unicodeData = {
    "fa-house": "\uf015",
    "fa-magnifying-glass": "\uf002",
    "fa-user": "\uf007",
    "fa-facebook": "\uf09a",
    "fa-check": "\uf00c",
    "fa-download": "\uf019",
    "fa-twitter": "\uf099",
    "fa-image": "\uf03e",
    "fa-instagram": "\uf16d",
    "fa-phone": "\uf095",
    "fa-tiktok": "\ue07b",
    "fa-bars": "\uf0c9",
    "fa-envelope": "\uf0e0",
    "fa-linkedin": "\uf08c",
    "fa-star": "\uf005",
    "fa-location-dot": "\uf3c5",
    "fa-github": "\uf09b",
    "fa-music": "\uf001",
    "fa-wand-magic-sparkles": "\ue2ca",
    "fa-face-awesome": "\ue409",
    "fa-heart": "\uf004",
    "fa-arrow-right": "\uf061",
    "fa-discord": "\uf392",
    "fa-circle-xmark": "\uf057",
    "fa-bomb": "\uf1e2",
    "fa-poo": "\uf2fe",
    "fa-camera-retro": "\uf083",
    "fa-xmark": "\uf00d",
    "fa-youtube": "\uf167",
    "fa-cloud": "\uf0c2",
    "fa-comment": "\uf075",
    "fa-caret-up": "\uf0d8",
    "fa-truck-fast": "\uf48b",
    "fa-wordpress": "\uf19a",
    "fa-pen-nib": "\uf5ad",
    "fa-arrow-up": "\uf062",
    "fa-hippo": "\uf6ed",
    "fa-face-smile": "\uf118",
    "fa-calendar-days": "\uf073",
    "fa-paperclip": "\uf0c6",
    "fa-slack": "\uf198",
    "fa-shield-halved": "\uf3ed",
    "fa-figma": "\uf799",
    "fa-file": "\uf15b",
    "fa-bell": "\uf0f3",
    "fa-cart-shopping": "\uf07a",
    "fa-clipboard": "\uf328",
    "fa-filter": "\uf0b0",
    "fa-circle-info": "\uf05a",
    "fa-arrow-up-from-bracket": "\ue09a",
    "fa-alarm-clock": "\uf34e",
    "fa-bolt": "\uf0e7",
    "fa-raygun": "\ue025",
    "fa-car": "\uf1b9",
    "fa-ghost": "\uf6e2",
    "fa-apple": "\uf179",
    "fa-mug-hot": "\uf7b6",
    "fa-circle-user": "\uf2bd",
    "fa-rocket-launch": "\ue027",
    "fa-pen": "\uf304",
    "fa-google": "\uf1a0",
    "fa-umbrella": "\uf0e9",
    "fa-gift": "\uf06b",
    "fa-film": "\uf008",
    "fa-grid-2": "\ue196",
    "fa-stripe": "\uf429",
    "fa-list": "\uf03a",
    "fa-gear": "\uf013",
    "fa-algolia": "\uf36c",
    "fa-trash": "\uf1f8",
    "fa-circle-up": "\uf35b",
    "fa-docker": "\uf395",
    "fa-circle-down": "\uf358",
    "fa-inbox": "\uf01c",
    "fa-rotate-right": "\uf2f9",
    "fa-sparkles": "\uf890",
    "fa-lock": "\uf023",
    "fa-windows": "\uf17a",
    "fa-headphones": "\uf025",
    "fa-volume": "\uf6a8",
    "fa-barcode": "\uf02a",
    "fa-tag": "\uf02b",
    "fa-book": "\uf02d",
    "fa-bookmark": "\uf02e",
    "fa-paypal": "\uf1ed",
    "fa-print": "\uf02f",
    "fa-camera": "\uf030",
    "fa-stack-overflow": "\uf16c",
    "fa-font": "\uf031",
    "fa-video": "\uf03d",
    "fa-circle-half-stroke": "\uf042",
    "fa-droplet": "\uf043",
    "fa-pen-to-square": "\uf044",
    "fa-share-from-square": "\uf14d",
    "fa-plus": "\u002b",
    "fa-minus": "\uf068",
    "fa-kickstarter": "\uf3bb",
    "fa-share": "\uf064",
    "fa-circle-exclamation": "\uf06a",
    "fa-fire": "\uf06d",
    "fa-eye": "\uf06e",
    "fa-eye-slash": "\uf070",
    "fa-dribbble": "\uf17d",
    "fa-plane": "\uf072",
    "fa-magnet": "\uf076",
    "fa-hand": "\uf256",
    "fa-folder": "\uf07b",
    "fa-folder-open": "\uf07c",
    "fa-money-bill": "\uf0d6",
    "fa-dropbox": "\uf16b",
    "fa-thumbs-up": "\uf164",
    "fa-thumbs-down": "\uf165",
    "fa-comments": "\uf086",
    "fa-grill-hot": "\ue5a5",
    "fa-lemon": "\uf094",
    "fa-key": "\uf084",
    "fa-thumbtack": "\uf08d",
    "fa-gears": "\uf085",
    "fa-paper-plane": "\uf1d8",
    "fa-code": "\uf121",
    "fa-squarespace": "\uf5be",
    "fa-globe": "\uf0ac",
    "fa-text": "\uf893",
    "fa-arrow-down-to-line": "\uf33d",
    "fa-truck": "\uf0d1",
    "fa-city": "\uf64f",
    "fa-ticket": "\uf145",
    "fa-tree": "\uf1bb",
    "fa-wifi": "\uf1eb",
    "fa-window": "\uf40e",
    "fa-burger-soda": "\uf858",
    "fa-camera-movie": "\uf8a9",
    "fa-paint-roller": "\uf5aa",
    "fa-bicycle": "\uf206",
    "fa-android": "\uf17b",
    "fa-sliders": "\uf1de",
    "fa-brush": "\uf55d",
    "fa-hashtag": "\u0023",
    "fa-megaphone": "\uf675",
    "fa-flask": "\uf0c3",
    "fa-briefcase": "\uf0b1",
    "fa-compass": "\uf14e",
    "fa-dumpster-fire": "\uf794",
    "fa-person": "\uf183",
    "fa-person-dress": "\uf182",
    "fa-shopify": "\ue057",
    "fa-balloons": "\ue2e4",
    "fa-address-book": "\uf2b9",
    "fa-bath": "\uf2cd",
    "fa-handshake": "\uf2b5",
    "fa-medium": "\uf23a",
    "fa-snowflake": "\uf2dc",
    "fa-right-to-bracket": "\uf2f6",
    "fa-earth-americas": "\uf57d",
    "fa-cloud-arrow-up": "\uf0ee",
    "fa-binoculars": "\uf1e5",
    "fa-palette": "\uf53f",
    "fa-codepen": "\uf1cb",
    "fa-layer-group": "\uf5fd",
    "fa-brackets-curly": "\uf7ea",
    "fa-users": "\uf0c0",
    "fa-gamepad": "\uf11b",
    "fa-business-time": "\uf64a",
    "fa-cloudflare": "\ue07d",
    "fa-feather": "\uf52d",
    "fa-sun": "\uf185",
    "fa-computer-classic": "\uf8b1",
    "fa-link": "\uf0c1",
    "fa-pen-fancy": "\uf5ac",
    "fa-airbnb": "\uf834",
    "fa-badge-check": "\uf336",
    "fa-fish": "\uf578",
    "fa-joystick": "\uf8c5",
    "fa-play-pause": "\ue22f",
    "fa-bug": "\uf188",
    "fa-shop": "\uf54f",
    "fa-mug-saucer": "\uf0f4",
    "fa-planet-ringed": "\ue020",
    "fa-vimeo": "\uf40a",
    "fa-landmark": "\uf66f",
    "fa-campfire": "\uf6ba",
    "fa-poo-storm": "\uf75a",
    "fa-whatsapp": "\uf232",
    "fa-chart-simple": "\ue473",
    "fa-shirt": "\uf553",
    "fa-files": "\ue178",
    "fa-dolphin": "\ue168",
    "fa-anchor": "\uf13d",
    "fa-quote-left": "\uf10d",
    "fa-atom-simple": "\uf5d3",
    "fa-bag-shopping": "\uf290",
    "fa-bed-front": "\uf8f7",
    "fa-people-simple": "\ue21b",
    "fa-gauge": "\uf624",
    "fa-signal-bars": "\uf690",
    "fa-code-compare": "\ue13a",
    "fa-user-secret": "\uf21b",
    "fa-stethoscope": "\uf0f1",
    "fa-car-side": "\uf5e4",
    "fa-hand-holding-heart": "\uf4be",
    "fa-ufo": "\ue047",
    "fa-alien-8bit": "\uf8f6",
    "fa-block-question": "\ue3dd",
    "fa-aperture": "\ue2df",
    "fa-bird": "\ue469",
    "fa-strawberry": "\ue32b",
    "fa-envelopes": "\ue170",
    "fa-intercom": "\uf7af",
    "fa-face-vomit": "\ue3a0",
    "fa-fort": "\ue486",
    "fa-truck-front": "\ue2b7",
    "fa-crab": "\ue3ff",
    "fa-user-bounty-hunter": "\ue2bf",
    "fa-thought-bubble": "\ue32e",
    "fa-cable-car": "\uf7da",
    "fa-mountain-sun": "\ue52f",
    "fa-traffic-cone": "\uf636",
    "fa-diagram-venn": "\ue15a",
    "fa-bowl-chopsticks-noodles": "\ue2ea",
    "fa-moped": "\ue3b9",
    "fa-burrito": "\uf7ed",
    "fa-robot-astromech": "\ue2d2",
    "fa-bat": "\uf6b5",
    "fa-location-pin": "\uf041",
    "fa-info": "\uf129",
    "fa-user-minus": "\uf503",
    "fa-calendar": "\uf133",
    "fa-cart-plus": "\uf217",
    "fa-clock": "\uf017",
    "fa-person-sign": "\uf757",
    "fa-circle": "\uf111",
    "fa-play": "\uf04b",
    "fa-cross": "\uf654",
    "fa-backward": "\uf04a",
    "fa-chart-scatter": "\uf7ee",
    "fa-handshake-slash": "\ue060",
    "fa-chevron-up": "\uf077",
    "fa-passport": "\uf5ab",
    "fa-usps": "\uf7e1",
    "fa-question": "3f",
    "fa-pencil": "\uf303",
    "fa-phone-volume": "\uf2a0",
    "fa-wix": "\uf5cf",
    "fa-car-building": "\uf859",
    "fa-head-side": "\uf6e9",
    "fa-upload": "\uf093",
    "fa-strikethrough": "\uf0cc",
    "fa-computer-speaker": "\uf8b2",
    "fa-line": "\uf3c0",
    "fa-credit-card": "\uf09d",
    "fa-street-view": "\uf21d",
    "fa-database": "\uf1c0",
    "fa-copy": "\uf0c5",
    "fa-mobile": "\uf3ce",
    "fa-square": "\uf0c8",
    "fa-sort": "\uf0dc",
    "fa-forward": "\uf04e",
    "fa-hourglass-start": "\uf251",
    "fa-behance": "\uf1b4",
    "fa-signal-slash": "\uf695",
    "fa-newspaper": "\uf1ea",
    "fa-notes-medical": "\uf481",
    "fa-table": "\uf0ce",
    "fa-building": "\uf1ad",
    "fa-globe-stand": "\uf5f6",
    "fa-square-heart": "\uf4c8",
    "fa-stop": "\uf04d",
    "fa-openid": "\uf19b",
    "fa-tally": "\uf69c",
    "fa-store": "\uf54e",
    "fa-flag": "\uf024",
    "fa-product-hunt": "\uf288",
    "fa-lightbulb-slash": "\uf673",
    "fa-file-excel": "\uf1c3",
    "fa-browser": "\uf37e",
    "fa-network-wired": "\uf6ff",
    "fa-cash-register": "\uf788",
    "fa-file-export": "\uf56e",
    "fa-internet-explorer": "\uf26b",
    "fa-hand-point-up": "\uf0a6",
    "fa-pagelines": "\uf18c",
    "fa-angle-up": "\uf106",
    "fa-shield": "\uf132",
    "fa-teamspeak": "\uf4f9",
    "fa-border-top": "\uf855",
    "fa-address-card": "\uf2bb",
    "fa-expand": "\uf065",
    "fa-flag-checkered": "\uf11e",
    "fa-html5": "\uf13b",
    "fa-quote-right": "\uf10e",
    "fa-tags": "\uf02c",
    "fa-server": "\uf233",
    "fa-user-nurse": "\uf82f",
    "fa-video-slash": "\uf4e2",
    "fa-arrow-down": "\uf063",
    "fa-blog": "\uf781",
    "fa-school": "\uf549",
    "fa-file-invoice": "\uf570",
    "fa-rocket": "\uf135",
    "fa-coin": "\uf85c",
    "fa-spinner": "\uf110",
    "fa-telegram": "\uf2c6",
    "fa-square-question": "\uf2fd",
    "fa-tty": "\uf1e4",
    "fa-exclamation": "\u0021",
    "fa-water": "\uf773",
    "fa-shield-check": "\uf2f7",
    "fa-registered": "\uf25d",
    "fa-empty-set": "\uf656",
    "fa-signature": "\uf5b7",
    "fa-laptop": "\uf109",
    "fa-phone-office": "\uf67d",
    "fa-line-height": "\uf871",
    "fa-transporter-3": "\ue045",
    "fa-projector": "\uf8d6",
    "fa-moon-stars": "\uf755",
    "fa-restroom": "\uf7bd",
    "fa-power-off": "\uf011",
    "fa-sitemap": "\uf0e8",
    "fa-icons": "\uf86d",
    "fa-desktop": "\uf390",
    "fa-moon": "\uf186",
    "fa-basketball-hoop": "\uf435",
    "fa-loveseat": "\uf4cc",
    "fa-square-info": "\uf30f",
    "fa-calendar-week": "\uf784",
    "fa-pinterest": "\uf0d2",
    "fa-pause": "\uf04c",
    "fa-file-word": "\uf1c2",
    "fa-triangle": "\uf2ec",
    "fa-watch": "\uf2e1",
    "fa-vials": "\uf493",
    "fa-language": "\uf1ab",
    "fa-door-open": "\uf52b",
    "fa-brain": "\uf5dc",
    "fa-hotel": "\uf594",
    "fa-marker": "\uf5a1",
    "fa-star-of-life": "\uf621",
    "fa-leaf": "\uf06c",
    "fa-walkie-talkie": "\uf8ef",
    "fa-person-dolly-empty": "\uf4d1",
    "fa-shower": "\uf2cc",
    "fa-dashcube": "\uf210",
    "fa-glass": "\uf804",
    "fa-mailbox": "\uf813",
    "fa-caret-down": "\uf0d7",
    "fa-ideal": "\ue013",
    "fa-light-switch": "\ue017",
    "fa-salesforce": "\uf83b",
    "fa-badge": "\uf335",
    "fa-file-import": "\uf56f",
    "fa-typewriter": "\uf8e7",
    "fa-place-of-worship": "\uf67f",
    "fa-flower": "\uf7ff",
    "fa-spinner-third": "\uf3f4",
    "fa-wallet": "\uf555",
    "fa-slash": "\uf715",
    "fa-readme": "\uf4d5",
    "fa-computer-mouse-scrollwheel": "\uf8cd",
    "fa-award": "\uf559",
    "fa-toggle-on": "\uf205",
    "fa-ship": "\uf21a",
    "fa-free-code-camp": "\uf2c5",
    "fa-file-check": "\uf316",
    "fa-soundcloud": "\uf1be",
    "fa-stocking": "\uf7d5",
    "fa-chalkboard": "\uf51b",
    "fa-square-twitter": "\uf081",
    "fa-planet-moon": "\ue01f",
    "fa-lights-holiday": "\uf7b2",
    "fa-hands": "\uf2a7",
    "fa-signal": "\uf012",
    "fa-radar": "\ue024",
    "fa-motorcycle": "\uf21c",
    "fa-booth-curtain": "\uf734",
    "fa-arrow-up-right-from-square": "\uf08e",
    "fa-audio-description": "\uf29e",
    "fa-accessible-icon": "\uf368",
    "fa-seedling": "\uf4d8",
    "fa-closed-captioning": "\uf20a",
    "fa-text-size": "\uf894",
    "fa-train": "\uf238",
    "fa-cc-visa": "\uf1f0",
    "fa-arrow-left": "\uf060",
    "fa-books": "\uf5db",
    "fa-wrench": "\uf0ad",
    "fa-microchip": "\uf2db",
    "fa-record-vinyl": "\uf8d9",
    "fa-goodreads-g": "\uf3a9",
    "fa-trophy": "\uf091",
    "fa-hammer": "\uf6e3",
    "fa-diamond": "\uf219",
    "fa-robot": "\uf544",
    "fa-file-pdf": "\uf1c1",
    "fa-tablet-rugged": "\uf48f",
    "fa-google-play": "\uf3ab",
    "fa-hospital": "\uf0f8",
    "fa-file-contract": "\uf56c",
    "fa-square-xmark": "\uf2d3",
    "fa-square-check": "\uf14a",
    "fa-stars": "\uf762",
    "fa-crown": "\uf521",
    "fa-react": "\uf41b",
    "fa-speaker": "\uf8df",
    "fa-ballot-check": "\uf733",
    "fa-speakers": "\uf8e0",
    "fa-user-plus": "\uf234",
    "fa-mug-tea": "\uf875",
    "fa-solar-system": "\ue02f",
    "fa-virus": "\ue074",
    "fa-child": "\uf1ae",
    "fa-scanner-touchscreen": "\uf48a",
    "fa-repeat": "\uf363",
    "fa-cube": "\uf1b2",
    "fa-copyright": "\uf1f9",
    "fa-medal": "\uf5a2",
    "fa-bullseye": "\uf140",
    "fa-mask": "\uf6fa",
    "fa-meat": "\uf814",
    "fa-circle-check": "\uf058",
    "fa-radio": "\uf8d7",
    "fa-reply": "\uf3e5",
    "fa-album": "\uf89f",
    "fa-chair": "\uf6c0",
    "fa-route": "\uf4d7",
    "fa-wikipedia-w": "\uf266",
    "fa-plug": "\uf1e6",
    "fa-calculator": "\uf1ec",
    "fa-dragon": "\uf6d5",
    "fa-certificate": "\uf0a3",
    "fa-fingerprint": "\uf577",
    "fa-road": "\uf018",
    "fa-crosshairs": "\uf05b",
    "fa-heading": "\uf1dc",
    "fa-percent": "\u0025",
    "fa-square-js": "\uf3b9",
    "fa-user-tie": "\uf508",
    "fa-java": "\uf4e4",
    "fa-square-minus": "\uf146",
    "fa-i-cursor": "\uf246",
    "fa-church": "\uf51d",
    "fa-joint": "\uf595",
    "fa-container-storage": "\uf4b7",
    "fa-comments-dollar": "\uf653",
    "fa-truck-monster": "\uf63b",
    "fa-recycle": "\uf1b8",
    "fa-square-pinterest": "\uf0d3",
    "fa-warehouse": "\uf494",
    "fa-ruler": "\uf545",
    "fa-font-case": "\uf866",
    "fa-python": "\uf3e2",
    "fa-police-box": "\ue021",
    "fa-soap": "\ue06e",
    "fa-starship-freighter": "\ue03a",
    "fa-bullseye-pointer": "\uf649",
    "fa-blanket": "\uf498",
    "fa-scroll": "\uf70e",
    "fa-skype": "\uf17e",
    "fa-coins": "\uf51e",
    "fa-house-night": "\ue010",
    "fa-alarm-snooze": "\uf845",
    "fa-wind": "\uf72e",
    "fa-baby": "\uf77c",
    "fa-lightbulb": "\uf0eb",
    "fa-file-exclamation": "\uf31a",
    "fa-transporter-empty": "\ue046",
    "fa-linux": "\uf17c",
    "fa-cauldron": "\uf6bf",
    "fa-node": "\uf419",
    "fa-rebel": "\uf1d0",
    "fa-voicemail": "\uf897",
    "fa-puzzle-piece": "\uf12e",
    "fa-keyboard": "\uf11c",
    "fa-clone": "\uf24d",
    "fa-eraser": "\uf12d",
    "fa-wine-bottle": "\uf72f",
    "fa-dice": "\uf522",
    "fa-file-spreadsheet": "\uf65b",
    "fa-receipt": "\uf543",
    "fa-ring": "\uf70b",
    "fa-etsy": "\uf2d7",
    "fa-lamp": "\uf4ca",
    "fa-wagon-covered": "\uf8ee",
    "fa-unlock": "\uf09c",
    "fa-discourse": "\uf393",
    "fa-solar-panel": "\uf5ba",
    "fa-ruler-vertical": "\uf548",
    "fa-circle-notch": "\uf1ce",
    "fa-people-arrows": "\ue068",
    "fa-flower-tulip": "\uf801",
    "fa-draw-square": "\uf5ef",
    "fa-engine-warning": "\uf5f2",
    "fa-raindrops": "\uf75c",
    "fa-rectangle-wide": "\uf2fc",
    "fa-dollar-sign": "\u0024",
    "fa-amazon": "\uf270",
    "fa-tablet": "\uf3fb",
    "fa-not-equal": "\uf53e",
    "fa-glasses": "\uf530",
    "fa-headset": "\uf590",
    "fa-code-branch": "\uf126",
    "fa-glide-g": "\uf2a6",
    "fa-gopuram": "\uf664",
    "fa-images": "\uf302",
    "fa-window-restore": "\uf2d2",
    "fa-industry": "\uf275",
    "fa-gitlab": "\uf296",
    "fa-spotify": "\uf1bc",
    "fa-staff": "\uf71b",
    "fa-stamp": "\uf5bf",
    "fa-microphone-slash": "\uf131",
    "fa-think-peaks": "\uf731",
    "fa-align-slash": "\uf846",
    "fa-microsoft": "\uf3ca",
    "fa-cookie-bite": "\uf564",
    "fa-otter": "\uf700",
    "fa-chevron-down": "\uf078",
    "fa-kiwi-bird": "\uf535",
    "fa-viruses": "\ue076",
    "fa-elementor": "\uf430",
    "fa-pied-piper": "\uf2ae",
    "fa-kidneys": "\uf5fb",
    "fa-users-medical": "\uf830",
    "fa-square-youtube": "\uf431",
    "fa-umbrella-beach": "\uf5ca",
    "fa-microwave": "\ue01b",
    "fa-subscript": "\uf12c",
    "fa-tablets": "\uf490",
    "fa-cc-mastercard": "\uf1f1",
    "fa-facebook-messenger": "\uf39f",
    "fa-atlassian": "\uf77b",
    "fa-knife-kitchen": "\uf6f5",
    "fa-game-console-handheld": "\uf8bb",
    "fa-playstation": "\uf3df",
    "fa-fly": "\uf417",
    "fa-transporter": "\ue042",
    "fa-microphone": "\uf130",
    "fa-meetup": "\uf2e0",
    "fa-blinds-raised": "\uf8fd",
    "fa-border-none": "\uf850",
    "fa-dumbbell": "\uf44b",
    "fa-twitch": "\uf1e8",
    "fa-plane-departure": "\uf5b0",
    "fa-waze": "\uf83f",
    "fa-z": "5a",
    "fa-yin-yang": "\uf6ad",
    "fa-yen-sign": "\uf157",
    "fa-y": "59",
    "fa-xmarks-lines": "\ue59a",
    "fa-xmark-to-slot": "\uf771",
    "fa-xmark-large": "\ue59b",
    "fa-x-ray": "\uf497",
    "fa-x": "58",
    "fa-wrench-simple": "\ue2d1",
    "fa-wreath-laurel": "\ue5d2",
    "fa-wreath": "\uf7e2",
    "fa-worm": "\ue599",
    "fa-won-sign": "\uf159",
    "fa-wine-glass-empty": "\uf5ce",
    "fa-wine-glass-crack": "\uf4bb",
    "fa-wine-glass": "\uf4e3",
    "fa-windsock": "\uf777",
    "fa-window-minimize": "\uf2d1",
    "fa-window-maximize": "\uf2d0",
    "fa-window-frame-open": "\ue050",
    "fa-window-frame": "\ue04f",
    "fa-window-flip": "\uf40f",
    "fa-wind-warning": "\uf776",
    "fa-wind-turbine": "\uf89b",
    "fa-wifi-weak": "\uf6aa",
    "fa-wifi-slash": "\uf6ac",
    "fa-wifi-fair": "\uf6ab",
    "fa-wifi-exclamation": "\ue2cf",
    "fa-whistle": "\uf460",
    "fa-whiskey-glass-ice": "\uf7a1",
    "fa-whiskey-glass": "\uf7a0",
    "fa-wheelchair-move": "\ue2ce",
    "fa-wheelchair": "\uf193",
    "fa-wheat-slash": "\ue339",
    "fa-wheat-awn-slash": "\ue338",
    "fa-wheat-awn-circle-exclamation": "\ue598",
    "fa-wheat-awn": "\ue2cd",
    "fa-wheat": "\uf72d",
    "fa-whale": "\uf72c",
    "fa-weight-scale": "\uf496",
    "fa-weight-hanging": "\uf5cd",
    "fa-webhook": "\ue5d5",
    "fa-web-awesome": "\ue682",
    "fa-waves-sine": "\ue65d",
    "fa-waveform-lines": "\uf8f2",
    "fa-waveform": "\uf8f1",
    "fa-wave-triangle": "\uf89a",
    "fa-wave-square": "\uf83e",
    "fa-wave-sine": "\uf899",
    "fa-wave-pulse": "\uf5f8",
    "fa-wave": "\ue65b",
    "fa-watermelon-slice": "\ue337",
    "fa-water-ladder": "\uf5c5",
    "fa-water-arrow-up": "\uf775",
    "fa-water-arrow-down": "\uf774",
    "fa-watch-smart": "\ue2cc",
    "fa-watch-fitness": "\uf63e",
    "fa-watch-calculator": "\uf8f0",
    "fa-watch-apple": "\ue2cb",
    "fa-washing-machine": "\uf898",
    "fa-warehouse-full": "\uf495",
    "fa-wand-sparkles": "\uf72b",
    "fa-wand-magic": "\uf0d0",
    "fa-wand": "\uf72a",
    "fa-walker": "\uf831",
    "fa-waffle": "\ue466",
    "fa-w": "57",
    "fa-vr-cardboard": "\uf729",
    "fa-volume-xmark": "\uf6a9",
    "fa-volume-slash": "\uf2e2",
    "fa-volume-off": "\uf026",
    "fa-volume-low": "\uf027",
    "fa-volume-high": "\uf028",
    "fa-volleyball": "\uf45f",
    "fa-volcano": "\uf770",
    "fa-virus-slash": "\ue075",
    "fa-virus-covid-slash": "\ue4a9",
    "fa-virus-covid": "\ue4a8",
    "fa-violin": "\uf8ed",
    "fa-vihara": "\uf6a7",
    "fa-video-plus": "\uf4e1",
    "fa-video-arrow-up-right": "\ue2c9",
    "fa-video-arrow-down-left": "\ue2c8",
    "fa-vial-virus": "\ue597",
    "fa-vial-circle-check": "\ue596",
    "fa-vial": "\uf492",
    "fa-vest-patches": "\ue086",
    "fa-vest": "\ue085",
    "fa-venus-mars": "\uf228",
    "fa-venus-double": "\uf226",
    "fa-venus": "\uf221",
    "fa-vent-damper": "\ue465",
    "fa-vector-square": "\uf5cb",
    "fa-vector-polygon": "\ue2c7",
    "fa-vector-circle": "\ue2c6",
    "fa-vault": "\ue2c5",
    "fa-van-shuttle": "\uf5b6",
    "fa-value-absolute": "\uf6a6",
    "fa-vacuum-robot": "\ue04e",
    "fa-vacuum": "\ue04d",
    "fa-v": "56",
    "fa-utility-pole-double": "\ue2c4",
    "fa-utility-pole": "\ue2c3",
    "fa-utensils-slash": "\ue464",
    "fa-utensils": "\uf2e7",
    "fa-users-viewfinder": "\ue595",
    "fa-users-slash": "\ue073",
    "fa-users-rectangle": "\ue594",
    "fa-users-rays": "\ue593",
    "fa-users-line": "\ue592",
    "fa-users-gear": "\uf509",
    "fa-users-between-lines": "\ue591",
    "fa-user-xmark": "\uf235",
    "fa-user-vneck-hair-long": "\ue463",
    "fa-user-vneck-hair": "\ue462",
    "fa-user-vneck": "\ue461",
    "fa-user-visor": "\ue04c",
    "fa-user-unlock": "\ue058",
    "fa-user-tie-hair-long": "\ue460",
    "fa-user-tie-hair": "\ue45f",
    "fa-user-tag": "\uf507",
    "fa-user-slash": "\uf506",
    "fa-user-shield": "\uf505",
    "fa-user-shakespeare": "\ue2c2",
    "fa-user-robot-xmarks": "\ue4a7",
    "fa-user-robot": "\ue04b",
    "fa-user-police-tie": "\ue334",
    "fa-user-police": "\ue333",
    "fa-user-pilot-tie": "\ue2c1",
    "fa-user-pilot": "\ue2c0",
    "fa-user-pen": "\uf4ff",
    "fa-user-nurse-hair-long": "\ue45e",
    "fa-user-nurse-hair": "\ue45d",
    "fa-user-ninja": "\uf504",
    "fa-user-music": "\uf8eb",
    "fa-user-magnifying-glass": "\ue5c5",
    "fa-user-lock": "\uf502",
    "fa-user-large-slash": "\uf4fa",
    "fa-user-large": "\uf406",
    "fa-user-injured": "\uf728",
    "fa-user-helmet-safety": "\uf82c",
    "fa-user-headset": "\uf82d",
    "fa-user-hair-mullet": "\ue45c",
    "fa-user-hair-long": "\ue45b",
    "fa-user-hair-buns": "\ue3d3",
    "fa-user-hair": "\ue45a",
    "fa-user-group-simple": "\ue603",
    "fa-user-group-crown": "\uf6a5",
    "fa-user-group": "\uf500",
    "fa-user-graduate": "\uf501",
    "fa-user-gear": "\uf4fe",
    "fa-user-doctor-message": "\uf82e",
    "fa-user-doctor-hair-long": "\ue459",
    "fa-user-doctor-hair": "\ue458",
    "fa-user-doctor": "\uf0f0",
    "fa-user-crown": "\uf6a4",
    "fa-user-cowboy": "\uf8ea",
    "fa-user-clock": "\uf4fd",
    "fa-user-chef": "\ue3d2",
    "fa-user-check": "\uf4fc",
    "fa-user-astronaut": "\uf4fb",
    "fa-user-alien": "\ue04a",
    "fa-usb-drive": "\uf8e9",
    "fa-up-to-line": "\uf34d",
    "fa-up-to-dotted-line": "\ue457",
    "fa-up-to-bracket": "\ue66e",
    "fa-up-right-from-square": "\uf35d",
    "fa-up-right-and-down-left-from-center": "\uf424",
    "fa-up-right": "\ue2be",
    "fa-up-long": "\uf30c",
    "fa-up-left": "\ue2bd",
    "fa-up-from-line": "\uf346",
    "fa-up-from-dotted-line": "\ue456",
    "fa-up-from-bracket": "\ue590",
    "fa-up-down-left-right": "\uf0b2",
    "fa-up-down": "\uf338",
    "fa-up": "\uf357",
    "fa-unlock-keyhole": "\uf13e",
    "fa-universal-access": "\uf29a",
    "fa-union": "\uf6a2",
    "fa-uniform-martial-arts": "\ue3d1",
    "fa-unicorn": "\uf727",
    "fa-underline": "\uf0cd",
    "fa-umbrella-simple": "\ue2bc",
    "fa-ufo-beam": "\ue048",
    "fa-u": "55",
    "fa-tv-retro": "\uf401",
    "fa-tv-music": "\uf8e6",
    "fa-tv": "\uf26c",
    "fa-turtle": "\uf726",
    "fa-turntable": "\uf8e4",
    "fa-turn-up": "\uf3bf",
    "fa-turn-right": "\ue639",
    "fa-turn-left-up": "\ue638",
    "fa-turn-left-down": "\ue637",
    "fa-turn-left": "\ue636",
    "fa-turn-down-right": "\ue455",
    "fa-turn-down-left": "\ue331",
    "fa-turn-down": "\uf3be",
    "fa-turkish-lira-sign": "\ue2bb",
    "fa-turkey": "\uf725",
    "fa-tugrik-sign": "\ue2ba",
    "fa-tty-answer": "\ue2b9",
    "fa-trumpet": "\uf8e3",
    "fa-truck-utensils": "\ue628",
    "fa-truck-tow": "\ue2b8",
    "fa-truck-ramp-couch": "\uf4dd",
    "fa-truck-ramp-box": "\uf4de",
    "fa-truck-ramp": "\uf4e0",
    "fa-truck-plow": "\uf7de",
    "fa-truck-plane": "\ue58f",
    "fa-truck-pickup": "\uf63c",
    "fa-truck-moving": "\uf4df",
    "fa-truck-medical": "\uf0f9",
    "fa-truck-ladder": "\ue657",
    "fa-truck-flatbed": "\ue2b6",
    "fa-truck-fire": "\ue65a",
    "fa-truck-field-un": "\ue58e",
    "fa-truck-field": "\ue58d",
    "fa-truck-droplet": "\ue58c",
    "fa-truck-container-empty": "\ue2b5",
    "fa-truck-container": "\uf4dc",
    "fa-truck-clock": "\uf48c",
    "fa-truck-bolt": "\ue3d0",
    "fa-truck-arrow-right": "\ue58b",
    "fa-trowel-bricks": "\ue58a",
    "fa-trowel": "\ue589",
    "fa-trophy-star": "\uf2eb",
    "fa-trillium": "\ue588",
    "fa-tricycle-adult": "\ue5c4",
    "fa-tricycle": "\ue5c3",
    "fa-triangle-person-digging": "\uf85d",
    "fa-triangle-instrument": "\uf8e2",
    "fa-triangle-exclamation": "\uf071",
    "fa-trees": "\uf724",
    "fa-tree-palm": "\uf82b",
    "fa-tree-large": "\uf7dd",
    "fa-tree-decorated": "\uf7dc",
    "fa-tree-deciduous": "\uf400",
    "fa-tree-city": "\ue587",
    "fa-tree-christmas": "\uf7db",
    "fa-treasure-chest": "\uf723",
    "fa-trash-xmark": "\ue2b4",
    "fa-trash-undo": "\uf895",
    "fa-trash-slash": "\ue2b3",
    "fa-trash-plus": "\ue2b2",
    "fa-trash-list": "\ue2b1",
    "fa-trash-clock": "\ue2b0",
    "fa-trash-check": "\ue2af",
    "fa-trash-can-xmark": "\ue2ae",
    "fa-trash-can-undo": "\uf896",
    "fa-trash-can-slash": "\ue2ad",
    "fa-trash-can-plus": "\ue2ac",
    "fa-trash-can-list": "\ue2ab",
    "fa-trash-can-clock": "\ue2aa",
    "fa-trash-can-check": "\ue2a9",
    "fa-trash-can-arrow-up": "\uf82a",
    "fa-trash-can": "\uf2ed",
    "fa-trash-arrow-up": "\uf829",
    "fa-transporter-7": "\ue2a8",
    "fa-transporter-6": "\ue2a7",
    "fa-transporter-5": "\ue2a6",
    "fa-transporter-4": "\ue2a5",
    "fa-transporter-2": "\ue044",
    "fa-transporter-1": "\ue043",
    "fa-transgender": "\uf225",
    "fa-transformer-bolt": "\ue2a4",
    "fa-train-tunnel": "\ue454",
    "fa-train-tram": "\ue5b4",
    "fa-train-track": "\ue453",
    "fa-train-subway-tunnel": "\ue2a3",
    "fa-train-subway": "\uf239",
    "fa-trailer": "\ue041",
    "fa-traffic-light-stop": "\uf63a",
    "fa-traffic-light-slow": "\uf639",
    "fa-traffic-light-go": "\uf638",
    "fa-traffic-light": "\uf637",
    "fa-trademark": "\uf25c",
    "fa-tractor": "\uf722",
    "fa-tower-observation": "\ue586",
    "fa-tower-control": "\ue2a2",
    "fa-tower-cell": "\ue585",
    "fa-tower-broadcast": "\uf519",
    "fa-tornado": "\uf76f",
    "fa-torii-gate": "\uf6a1",
    "fa-toothbrush": "\uf635",
    "fa-tooth": "\uf5c9",
    "fa-toolbox": "\uf552",
    "fa-tombstone-blank": "\uf721",
    "fa-tombstone": "\uf720",
    "fa-tomato": "\ue330",
    "fa-toilets-portable": "\ue584",
    "fa-toilet-portable": "\ue583",
    "fa-toilet-paper-xmark": "\ue5b3",
    "fa-toilet-paper-under-slash": "\ue2a1",
    "fa-toilet-paper-under": "\ue2a0",
    "fa-toilet-paper-slash": "\ue072",
    "fa-toilet-paper-check": "\ue5b2",
    "fa-toilet-paper-blank-under": "\ue29f",
    "fa-toilet-paper-blank": "\uf71f",
    "fa-toilet-paper": "\uf71e",
    "fa-toilet": "\uf7d8",
    "fa-toggle-off": "\uf204",
    "fa-toggle-large-on": "\ue5b1",
    "fa-toggle-large-off": "\ue5b0",
    "fa-tire-rugged": "\uf634",
    "fa-tire-pressure-warning": "\uf633",
    "fa-tire-flat": "\uf632",
    "fa-tire": "\uf631",
    "fa-timer": "\ue29e",
    "fa-timeline-arrow": "\ue29d",
    "fa-timeline": "\ue29c",
    "fa-tilde": "7e",
    "fa-tickets-simple": "\ue659",
    "fa-tickets-perforated": "\ue63f",
    "fa-tickets-airline": "\ue29b",
    "fa-tickets": "\ue658",
    "fa-ticket-simple": "\uf3ff",
    "fa-ticket-perforated": "\ue63e",
    "fa-ticket-airline": "\ue29a",
    "fa-tick": "\ue32f",
    "fa-theta": "\uf69e",
    "fa-thermometer": "\uf491",
    "fa-text-width": "\uf035",
    "fa-text-slash": "\uf87d",
    "fa-text-height": "\uf034",
    "fa-terminal": "\uf120",
    "fa-tents": "\ue582",
    "fa-tent-double-peak": "\ue627",
    "fa-tent-arrows-down": "\ue581",
    "fa-tent-arrow-turn-left": "\ue580",
    "fa-tent-arrow-left-right": "\ue57f",
    "fa-tent-arrow-down-to-line": "\ue57e",
    "fa-tent": "\ue57d",
    "fa-tennis-ball": "\uf45e",
    "fa-tenge-sign": "\uf7d7",
    "fa-temperature-three-quarters": "\uf2c8",
    "fa-temperature-sun": "\uf76a",
    "fa-temperature-snow": "\uf768",
    "fa-temperature-quarter": "\uf2ca",
    "fa-temperature-low": "\uf76b",
    "fa-temperature-list": "\ue299",
    "fa-temperature-high": "\uf769",
    "fa-temperature-half": "\uf2c9",
    "fa-temperature-full": "\uf2c7",
    "fa-temperature-empty": "\uf2cb",
    "fa-temperature-arrow-up": "\ue040",
    "fa-temperature-arrow-down": "\ue03f",
    "fa-telescope": "\ue03e",
    "fa-teeth-open": "\uf62f",
    "fa-teeth": "\uf62e",
    "fa-teddy-bear": "\ue3cf",
    "fa-taxi-bus": "\ue298",
    "fa-taxi": "\uf1ba",
    "fa-tarp-droplet": "\ue57c",
    "fa-tape": "\uf4db",
    "fa-tank-water": "\ue452",
    "fa-tamale": "\ue451",
    "fa-tally-4": "\ue297",
    "fa-tally-3": "\ue296",
    "fa-tally-2": "\ue295",
    "fa-tally-1": "\ue294",
    "fa-taco": "\uf826",
    "fa-tachograph-digital": "\uf566",
    "fa-tablet-screen-button": "\uf3fa",
    "fa-tablet-screen": "\uf3fc",
    "fa-tablet-button": "\uf10a",
    "fa-table-tree": "\ue293",
    "fa-table-tennis-paddle-ball": "\uf45d",
    "fa-table-rows": "\ue292",
    "fa-table-pivot": "\ue291",
    "fa-table-picnic": "\ue32d",
    "fa-table-list": "\uf00b",
    "fa-table-layout": "\ue290",
    "fa-table-columns": "\uf0db",
    "fa-table-cells-row-lock": "\ue67a",
    "fa-table-cells-lock": "\ue679",
    "fa-table-cells-large": "\uf009",
    "fa-table-cells-column-lock": "\ue678",
    "fa-table-cells": "\uf00a",
    "fa-t-rex": "\ue629",
    "fa-t": "54",
    "fa-syringe": "\uf48e",
    "fa-synagogue": "\uf69b",
    "fa-symbols": "\uf86e",
    "fa-swords-laser": "\ue03d",
    "fa-swords": "\uf71d",
    "fa-sword-laser-alt": "\ue03c",
    "fa-sword-laser": "\ue03b",
    "fa-sword": "\uf71c",
    "fa-swatchbook": "\uf5c3",
    "fa-swap-arrows": "\ue60a",
    "fa-swap": "\ue609",
    "fa-sushi-roll": "\ue48b",
    "fa-sushi": "\ue48a",
    "fa-superscript": "\uf12b",
    "fa-sunset": "\uf767",
    "fa-sunrise": "\uf766",
    "fa-sunglasses": "\uf892",
    "fa-tarp": "\ue57b",
    "fa-sun-plant-wilt": "\ue57a",
    "fa-sun-haze": "\uf765",
    "fa-sun-dust": "\uf764",
    "fa-sun-cloud": "\uf763",
    "fa-sun-bright": "\ue28f",
    "fa-suitcase-rolling": "\uf5c1",
    "fa-suitcase-medical": "\uf0fa",
    "fa-suitcase": "\uf0f2",
    "fa-subtitles-slash": "\ue610",
    "fa-subtitles": "\ue60f",
    "fa-stroopwafel": "\uf551",
    "fa-stretcher": "\uf825",
    "fa-store-slash": "\ue071",
    "fa-store-lock": "\ue4a6",
    "fa-stopwatch-20": "\ue06f",
    "fa-stopwatch": "\uf2f2",
    "fa-stomach": "\uf623",
    "fa-sterling-sign": "\uf154",
    "fa-steering-wheel": "\uf622",
    "fa-steak": "\uf824",
    "fa-starship": "\ue039",
    "fa-starfighter-twin-ion-engine-advanced": "\ue28e",
    "fa-starfighter-twin-ion-engine": "\ue038",
    "fa-starfighter": "\ue037",
    "fa-star-shooting": "\ue036",
    "fa-star-sharp-half-stroke": "\ue28d",
    "fa-star-sharp-half": "\ue28c",
    "fa-star-sharp": "\ue28b",
    "fa-star-of-david": "\uf69a",
    "fa-star-half-stroke": "\uf5c0",
    "fa-star-half": "\uf089",
    "fa-star-exclamation": "\uf2f3",
    "fa-star-christmas": "\uf7d4",
    "fa-star-and-crescent": "\uf699",
    "fa-stapler": "\ue5af",
    "fa-standard-definition": "\ue28a",
    "fa-stairs": "\ue289",
    "fa-staff-snake": "\ue579",
    "fa-squirrel": "\uf71a",
    "fa-squid": "\ue450",
    "fa-square-z": "\ue288",
    "fa-square-y": "\ue287",
    "fa-square-x": "\ue286",
    "fa-square-w": "\ue285",
    "fa-square-virus": "\ue578",
    "fa-square-v": "\ue284",
    "fa-square-user": "\ue283",
    "fa-square-up-right": "\uf360",
    "fa-square-up-left": "\ue282",
    "fa-square-up": "\uf353",
    "fa-square-u": "\ue281",
    "fa-square-this-way-up": "\uf49f",
    "fa-square-terminal": "\ue32a",
    "fa-square-t": "\ue280",
    "fa-square-star": "\ue27f",
    "fa-square-small": "\ue27e",
    "fa-square-sliders-vertical": "\uf3f2",
    "fa-square-sliders": "\uf3f0",
    "fa-square-share-nodes": "\uf1e1",
    "fa-square-s": "\ue27d",
    "fa-square-rss": "\uf143",
    "fa-square-root-variable": "\uf698",
    "fa-square-root": "\uf697",
    "fa-square-ring": "\ue44f",
    "fa-square-right": "\uf352",
    "fa-square-r": "\ue27c",
    "fa-square-quote": "\ue329",
    "fa-square-quarters": "\ue44e",
    "fa-square-q": "\ue27b",
    "fa-square-poll-vertical": "\uf681",
    "fa-square-poll-horizontal": "\uf682",
    "fa-square-plus": "\uf0fe",
    "fa-square-phone-hangup": "\ue27a",
    "fa-square-phone-flip": "\uf87b",
    "fa-square-phone": "\uf098",
    "fa-square-person-confined": "\ue577",
    "fa-square-pen": "\uf14b",
    "fa-square-parking-slash": "\uf617",
    "fa-square-parking": "\uf540",
    "fa-square-p": "\ue279",
    "fa-square-o": "\ue278",
    "fa-square-nfi": "\ue576",
    "fa-square-n": "\ue277",
    "fa-square-m": "\ue276",
    "fa-square-list": "\ue489",
    "fa-square-left": "\uf351",
    "fa-square-l": "\ue275",
    "fa-square-kanban": "\ue488",
    "fa-square-k": "\ue274",
    "fa-square-j": "\ue273",
    "fa-square-i": "\ue272",
    "fa-square-h": "\uf0fd",
    "fa-square-g": "\ue271",
    "fa-square-full": "\uf45c",
    "fa-square-fragile": "\uf49b",
    "fa-square-f": "\ue270",
    "fa-square-exclamation": "\uf321",
    "fa-square-envelope": "\uf199",
    "fa-square-ellipsis-vertical": "\ue26f",
    "fa-square-ellipsis": "\ue26e",
    "fa-square-e": "\ue26d",
    "fa-square-down-right": "\ue26c",
    "fa-square-down-left": "\ue26b",
    "fa-square-down": "\uf350",
    "fa-square-dollar": "\uf2e9",
    "fa-square-divide": "\ue26a",
    "fa-square-dashed-circle-plus": "\ue5c2",
    "fa-square-dashed": "\ue269",
    "fa-square-d": "\ue268",
    "fa-square-code": "\ue267",
    "fa-square-chevron-up": "\uf32c",
    "fa-square-chevron-right": "\uf32b",
    "fa-square-chevron-left": "\uf32a",
    "fa-square-chevron-down": "\uf329",
    "fa-square-caret-up": "\uf151",
    "fa-square-caret-right": "\uf152",
    "fa-square-caret-left": "\uf191",
    "fa-square-caret-down": "\uf150",
    "fa-square-c": "\ue266",
    "fa-square-bolt": "\ue265",
    "fa-square-b": "\ue264",
    "fa-square-arrow-up-right": "\uf14c",
    "fa-square-arrow-up-left": "\ue263",
    "fa-square-arrow-up": "\uf33c",
    "fa-square-arrow-right": "\uf33b",
    "fa-square-arrow-left": "\uf33a",
    "fa-square-arrow-down-right": "\ue262",
    "fa-square-arrow-down-left": "\ue261",
    "fa-square-arrow-down": "\uf339",
    "fa-square-ampersand": "\ue260",
    "fa-square-a-lock": "\ue44d",
    "fa-square-a": "\ue25f",
    "fa-square-9": "\ue25e",
    "fa-square-8": "\ue25d",
    "fa-square-7": "\ue25c",
    "fa-square-5": "\ue25a",
    "fa-square-4": "\ue259",
    "fa-square-3": "\ue258",
    "fa-square-2": "\ue257",
    "fa-square-1": "\ue256",
    "fa-square-0": "\ue255",
    "fa-sprinkler-ceiling": "\ue44c",
    "fa-sprinkler": "\ue035",
    "fa-spray-can-sparkles": "\uf5d0",
    "fa-spray-can": "\uf5bd",
    "fa-sportsball": "\ue44b",
    "fa-spoon": "\uf2e5",
    "fa-splotch": "\uf5bc",
    "fa-split": "\ue254",
    "fa-spinner-scale": "\ue62a",
    "fa-spider-web": "\uf719",
    "fa-spider-black-widow": "\uf718",
    "fa-spider": "\uf717",
    "fa-spell-check": "\uf891",
    "fa-sparkle": "\ue5d6",
    "fa-spaghetti-monster-flying": "\uf67b",
    "fa-spade": "\uf2f4",
    "fa-space-station-moon-construction": "\ue034",
    "fa-space-station-moon": "\ue033",
    "fa-spa": "\uf5bb",
    "fa-sort-up": "\uf0de",
    "fa-sort-down": "\uf0dd",
    "fa-soft-serve": "\ue400",
    "fa-socks": "\uf696",
    "fa-snowplow": "\uf7d2",
    "fa-snowman-head": "\uf79b",
    "fa-snowman": "\uf7d0",
    "fa-snowflakes": "\uf7cf",
    "fa-snowflake-droplets": "\ue5c1",
    "fa-snow-blowing": "\uf761",
    "fa-snooze": "\uf880",
    "fa-snake": "\uf716",
    "fa-smoking": "\uf48d",
    "fa-smoke": "\uf760",
    "fa-smog": "\uf75f",
    "fa-slot-machine": "\ue3ce",
    "fa-sliders-up": "\uf3f1",
    "fa-sliders-simple": "\ue253",
    "fa-slider": "\ue252",
    "fa-sleigh": "\uf7cc",
    "fa-slash-forward": "\u002f",
    "fa-slash-back": "5c",
    "fa-square-6": "\ue25b",
    "fa-skull-crossbones": "\uf714",
    "fa-skull-cow": "\uf8de",
    "fa-skull": "\uf54c",
    "fa-ski-boot-ski": "\ue3cd",
    "fa-ski-boot": "\ue3cc",
    "fa-skeleton-ribs": "\ue5cb",
    "fa-skeleton": "\uf620",
    "fa-siren-on": "\ue02e",
    "fa-siren": "\ue02d",
    "fa-sink": "\ue06d",
    "fa-sim-cards": "\ue251",
    "fa-sim-card": "\uf7c4",
    "fa-signs-post": "\uf277",
    "fa-signature-slash": "\ue3cb",
    "fa-signature-lock": "\ue3ca",
    "fa-signal-weak": "\uf68c",
    "fa-signal-strong": "\uf68f",
    "fa-signal-stream-slash": "\ue250",
    "fa-signal-stream": "\uf8dd",
    "fa-signal-good": "\uf68e",
    "fa-signal-fair": "\uf68d",
    "fa-signal-bars-weak": "\uf691",
    "fa-signal-bars-slash": "\uf694",
    "fa-signal-bars-good": "\uf693",
    "fa-signal-bars-fair": "\uf692",
    "fa-sign-posts-wrench": "\ue626",
    "fa-sign-posts": "\ue625",
    "fa-sign-post": "\ue624",
    "fa-sign-hanging": "\uf4d9",
    "fa-sigma": "\uf68b",
    "fa-sidebar-flip": "\ue24f",
    "fa-sidebar": "\ue24e",
    "fa-sickle": "\uf822",
    "fa-shuttlecock": "\uf45b",
    "fa-shuttle-space": "\uf197",
    "fa-shutters": "\ue449",
    "fa-shuffle": "\uf074",
    "fa-shrimp": "\ue448",
    "fa-shredder": "\uf68a",
    "fa-shower-down": "\ue24d",
    "fa-shovel-snow": "\uf7c3",
    "fa-shovel": "\uf713",
    "fa-shop-slash": "\ue070",
    "fa-shop-lock": "\ue4a5",
    "fa-shoe-prints": "\uf54b",
    "fa-shish-kebab": "\uf821",
    "fa-shirt-tank-top": "\ue3c9",
    "fa-shirt-running": "\ue3c8",
    "fa-shirt-long-sleeve": "\ue3c7",
    "fa-shield-xmark": "\ue24c",
    "fa-shield-virus": "\ue06c",
    "fa-shield-slash": "\ue24b",
    "fa-shield-quartered": "\ue575",
    "fa-shield-plus": "\ue24a",
    "fa-shield-minus": "\ue249",
    "fa-shield-keyhole": "\ue248",
    "fa-shield-heart": "\ue574",
    "fa-shield-exclamation": "\ue247",
    "fa-shield-dog": "\ue573",
    "fa-shield-cross": "\uf712",
    "fa-shield-cat": "\ue572",
    "fa-shelves-empty": "\ue246",
    "fa-shelves": "\uf480",
    "fa-shekel-sign": "\uf20b",
    "fa-sheet-plastic": "\ue571",
    "fa-sheep": "\uf711",
    "fa-share-nodes": "\uf1e0",
    "fa-share-all": "\uf367",
    "fa-shapes": "\uf61f",
    "fa-sensor-triangle-exclamation": "\ue029",
    "fa-sensor-on": "\ue02b",
    "fa-sensor-fire": "\ue02a",
    "fa-sensor-cloud": "\ue02c",
    "fa-sensor": "\ue028",
    "fa-send-backward": "\uf87f",
    "fa-send-back": "\uf87e",
    "fa-semicolon": "3b",
    "fa-section": "\ue447",
    "fa-seat-airline": "\ue244",
    "fa-seal-question": "\ue243",
    "fa-seal-exclamation": "\ue242",
    "fa-seal": "\ue241",
    "fa-sd-cards": "\ue240",
    "fa-sd-card": "\uf7c2",
    "fa-scythe": "\uf710",
    "fa-scrubber": "\uf2f8",
    "fa-scroll-torah": "\uf6a0",
    "fa-scroll-old": "\uf70f",
    "fa-scribble": "\ue23f",
    "fa-screwdriver-wrench": "\uf7d9",
    "fa-screwdriver": "\uf54a",
    "fa-screencast": "\ue23e",
    "fa-screen-users": "\uf63d",
    "fa-scissors": "\uf0c4",
    "fa-school-lock": "\ue56f",
    "fa-school-flag": "\ue56e",
    "fa-school-circle-xmark": "\ue56d",
    "fa-school-circle-exclamation": "\ue56c",
    "fa-school-circle-check": "\ue56b",
    "fa-scarf": "\uf7c1",
    "fa-scarecrow": "\uf70d",
    "fa-scanner-keyboard": "\uf489",
    "fa-scanner-image": "\uf8f3",
    "fa-scanner-gun": "\uf488",
    "fa-scalpel-line-dashed": "\uf61e",
    "fa-scalpel": "\uf61d",
    "fa-scale-unbalanced-flip": "\uf516",
    "fa-scale-unbalanced": "\uf515",
    "fa-scale-balanced": "\uf24e",
    "fa-saxophone-fire": "\uf8db",
    "fa-saxophone": "\uf8dc",
    "fa-sausage": "\uf820",
    "fa-satellite-dish": "\uf7c0",
    "fa-satellite": "\uf7bf",
    "fa-sandwich": "\uf81f",
    "fa-salt-shaker": "\ue446",
    "fa-salad": "\uf81e",
    "fa-sailboat": "\ue445",
    "fa-sack-xmark": "\ue56a",
    "fa-sack-dollar": "\uf81d",
    "fa-sack": "\uf81c",
    "fa-s": "53",
    "fa-rv": "\uf7be",
    "fa-rupiah-sign": "\ue23d",
    "fa-rupee-sign": "\uf156",
    "fa-ruler-triangle": "\uf61c",
    "fa-ruler-horizontal": "\uf547",
    "fa-ruler-combined": "\uf546",
    "fa-rugby-ball": "\ue3c6",
    "fa-rug": "\ue569",
    "fa-ruble-sign": "\uf158",
    "fa-rss": "\uf09e",
    "fa-router": "\uf8da",
    "fa-route-interstate": "\uf61b",
    "fa-route-highway": "\uf61a",
    "fa-rotate-reverse": "\ue631",
    "fa-rotate-left": "\uf2ea",
    "fa-rotate-exclamation": "\ue23c",
    "fa-rotate": "\uf2f1",
    "fa-roller-coaster": "\ue324",
    "fa-road-spikes": "\ue568",
    "fa-road-lock": "\ue567",
    "fa-road-circle-xmark": "\ue566",
    "fa-road-circle-exclamation": "\ue565",
    "fa-road-circle-check": "\ue564",
    "fa-road-bridge": "\ue563",
    "fa-road-barrier": "\ue562",
    "fa-rings-wedding": "\uf81b",
    "fa-ring-diamond": "\ue5ab",
    "fa-right-to-line": "\uf34c",
    "fa-right-long-to-line": "\ue444",
    "fa-right-long": "\uf30b",
    "fa-right-left-large": "\ue5e1",
    "fa-right-left": "\uf362",
    "fa-right-from-line": "\uf347",
    "fa-right-from-bracket": "\uf2f5",
    "fa-right": "\uf356",
    "fa-ribbon": "\uf4d6",
    "fa-rhombus": "\ue23b",
    "fa-retweet": "\uf079",
    "fa-restroom-simple": "\ue23a",
    "fa-republican": "\uf75e",
    "fa-reply-clock": "\ue239",
    "fa-reply-all": "\uf122",
    "fa-repeat-1": "\uf365",
    "fa-refrigerator": "\ue026",
    "fa-reflect-vertical": "\ue665",
    "fa-reflect-horizontal": "\ue664",
    "fa-reflect-both": "\ue66f",
    "fa-reel": "\ue238",
    "fa-rectangles-mixed": "\ue323",
    "fa-rectangle-xmark": "\uf410",
    "fa-rectangle-vertical-history": "\ue237",
    "fa-rectangle-vertical": "\uf2fb",
    "fa-rectangle-terminal": "\ue236",
    "fa-rectangle-pro": "\ue235",
    "fa-rectangle-list": "\uf022",
    "fa-rectangle-history-circle-user": "\ue4a4",
    "fa-rectangle-history-circle-plus": "\ue4a3",
    "fa-rectangle-history": "\ue4a2",
    "fa-rectangle-code": "\ue322",
    "fa-rectangle-barcode": "\uf463",
    "fa-rectangle-ad": "\uf641",
    "fa-rectangle": "\uf2fa",
    "fa-ranking-star": "\ue561",
    "fa-ramp-loading": "\uf4d4",
    "fa-ram": "\uf70a",
    "fa-rainbow": "\uf75b",
    "fa-radio-tuner": "\uf8d8",
    "fa-radiation": "\uf7b9",
    "fa-racquet": "\uf45a",
    "fa-raccoon": "\ue613",
    "fa-rabbit-running": "\uf709",
    "fa-rabbit": "\uf708",
    "fa-r": "52",
    "fa-quotes": "\ue234",
    "fa-qrcode": "\uf029",
    "fa-q": "51",
    "fa-puzzle-piece-simple": "\ue231",
    "fa-puzzle": "\ue443",
    "fa-pumpkin": "\uf707",
    "fa-pump-soap": "\ue06b",
    "fa-pump-medical": "\ue06a",
    "fa-pump": "\ue442",
    "fa-print-slash": "\uf686",
    "fa-print-magnifying-glass": "\uf81a",
    "fa-pretzel": "\ue441",
    "fa-presentation-screen": "\uf685",
    "fa-prescription-bottle-pill": "\ue5c0",
    "fa-prescription-bottle-medical": "\uf486",
    "fa-prescription-bottle": "\uf485",
    "fa-prescription": "\uf5b1",
    "fa-potato": "\ue440",
    "fa-pot-food": "\ue43f",
    "fa-popsicle": "\ue43e",
    "fa-popcorn": "\uf819",
    "fa-poop": "\uf619",
    "fa-pool-8-ball": "\ue3c5",
    "fa-pompebled": "\ue43d",
    "fa-poll-people": "\uf759",
    "fa-podium-star": "\uf758",
    "fa-podium": "\uf680",
    "fa-podcast": "\uf2ce",
    "fa-plus-minus": "\ue43c",
    "fa-plus-large": "\ue59e",
    "fa-plug-circle-xmark": "\ue560",
    "fa-plug-circle-plus": "\ue55f",
    "fa-plug-circle-minus": "\ue55e",
    "fa-plug-circle-exclamation": "\ue55d",
    "fa-plug-circle-check": "\ue55c",
    "fa-plug-circle-bolt": "\ue55b",
    "fa-plate-wheat": "\ue55a",
    "fa-plate-utensils": "\ue43b",
    "fa-plant-wilt": "\ue5aa",
    "fa-plane-up-slash": "\ue22e",
    "fa-plane-up": "\ue22d",
    "fa-plane-tail": "\ue22c",
    "fa-plane-slash": "\ue069",
    "fa-plane-prop": "\ue22b",
    "fa-plane-lock": "\ue558",
    "fa-plane-engines": "\uf3de",
    "fa-plane-circle-xmark": "\ue557",
    "fa-plane-circle-exclamation": "\ue556",
    "fa-plane-circle-check": "\ue555",
    "fa-plane-arrival": "\uf5af",
    "fa-pizza-slice": "\uf818",
    "fa-pizza": "\uf817",
    "fa-pipe-valve": "\ue439",
    "fa-pipe-smoking": "\ue3c4",
    "fa-pipe-section": "\ue438",
    "fa-pipe-collar": "\ue437",
    "fa-pipe-circle-check": "\ue436",
    "fa-pipe": "7c",
    "fa-pineapple": "\ue31f",
    "fa-pinball": "\ue229",
    "fa-pinata": "\ue3c3",
    "fa-pills": "\uf484",
    "fa-piggy-bank": "\uf4d3",
    "fa-pig": "\uf706",
    "fa-pie": "\uf705",
    "fa-pickleball": "\ue435",
    "fa-pickaxe": "\ue5bf",
    "fa-piano-keyboard": "\uf8d5",
    "fa-piano": "\uf8d4",
    "fa-pi": "\uf67e",
    "fa-photo-film-music": "\ue228",
    "fa-photo-film": "\uf87c",
    "fa-phone-xmark": "\ue227",
    "fa-phone-slash": "\uf3dd",
    "fa-phone-rotary": "\uf8d3",
    "fa-phone-plus": "\uf4d2",
    "fa-phone-missed": "\ue226",
    "fa-phone-intercom": "\ue434",
    "fa-phone-hangup": "\ue225",
    "fa-phone-flip": "\uf879",
    "fa-phone-arrow-up-right": "\ue224",
    "fa-phone-arrow-right": "\ue5be",
    "fa-phone-arrow-down-left": "\ue223",
    "fa-peso-sign": "\ue222",
    "fa-peseta-sign": "\ue221",
    "fa-person-walking-with-cane": "\uf29d",
    "fa-person-walking-luggage": "\ue554",
    "fa-person-walking-dashed-line-arrow-right": "\ue553",
    "fa-person-walking-arrow-right": "\ue552",
    "fa-person-walking-arrow-loop-left": "\ue551",
    "fa-person-walking": "\uf554",
    "fa-person-to-portal": "\ue022",
    "fa-person-to-door": "\ue433",
    "fa-person-through-window": "\ue5a9",
    "fa-person-swimming": "\uf5c4",
    "fa-person-snowmobiling": "\uf7d1",
    "fa-person-snowboarding": "\uf7ce",
    "fa-person-sledding": "\uf7cb",
    "fa-person-skiing-nordic": "\uf7ca",
    "fa-person-skiing": "\uf7c9",
    "fa-person-ski-lift": "\uf7c8",
    "fa-person-ski-jumping": "\uf7c7",
    "fa-person-skating": "\uf7c5",
    "fa-person-simple": "\ue220",
    "fa-person-shelter": "\ue54f",
    "fa-person-seat-reclined": "\ue21f",
    "fa-person-seat": "\ue21e",
    "fa-person-running-fast": "\ue5ff",
    "fa-person-running": "\uf70c",
    "fa-person-rifle": "\ue54e",
    "fa-person-rays": "\ue54d",
    "fa-person-pregnant": "\ue31e",
    "fa-person-praying": "\uf683",
    "fa-person-pinball": "\ue21d",
    "fa-person-military-to-person": "\ue54c",
    "fa-person-military-rifle": "\ue54b",
    "fa-person-military-pointing": "\ue54a",
    "fa-person-hiking": "\uf6ec",
    "fa-person-harassing": "\ue549",
    "fa-person-half-dress": "\ue548",
    "fa-person-from-portal": "\ue023",
    "fa-person-falling-burst": "\ue547",
    "fa-person-falling": "\ue546",
    "fa-person-fairy": "\ue608",
    "fa-person-drowning": "\ue545",
    "fa-person-dress-simple": "\ue21c",
    "fa-person-dress-fairy": "\ue607",
    "fa-person-dress-burst": "\ue544",
    "fa-person-dots-from-line": "\uf470",
    "fa-person-dolly": "\uf4d0",
    "fa-person-digging": "\uf85e",
    "fa-person-circle-xmark": "\ue543",
    "fa-person-circle-question": "\ue542",
    "fa-person-circle-plus": "\ue541",
    "fa-person-circle-minus": "\ue540",
    "fa-person-circle-exclamation": "\ue53f",
    "fa-person-circle-check": "\ue53e",
    "fa-person-chalkboard": "\ue53d",
    "fa-person-carry-box": "\uf4cf",
    "fa-person-cane": "\ue53c",
    "fa-person-burst": "\ue53b",
    "fa-person-breastfeeding": "\ue53a",
    "fa-person-booth": "\uf756",
    "fa-person-biking-mountain": "\uf84b",
    "fa-person-biking": "\uf84a",
    "fa-person-arrow-up-from-line": "\ue539",
    "fa-person-arrow-down-to-line": "\ue538",
    "fa-period": "\u002e",
    "fa-pepper-hot": "\uf816",
    "fa-pepper": "\ue432",
    "fa-people-roof": "\ue537",
    "fa-people-robbery": "\ue536",
    "fa-people-pulling": "\ue535",
    "fa-people-pants-simple": "\ue21a",
    "fa-people-pants": "\ue219",
    "fa-people-line": "\ue534",
    "fa-people-group": "\ue533",
    "fa-people-dress-simple": "\ue218",
    "fa-people-dress": "\ue217",
    "fa-people-carry-box": "\uf4ce",
    "fa-people": "\ue216",
    "fa-pencil-slash": "\ue215",
    "fa-pencil-mechanical": "\ue5ca",
    "fa-pen-swirl": "\ue214",
    "fa-pen-slash": "\ue213",
    "fa-pen-ruler": "\uf5ae",
    "fa-pen-paintbrush": "\uf618",
    "fa-pen-nib-slash": "\ue4a1",
    "fa-pen-line": "\ue212",
    "fa-pen-field": "\ue211",
    "fa-pen-fancy-slash": "\ue210",
    "fa-pen-clip-slash": "\ue20f",
    "fa-pen-clip": "\uf305",
    "fa-pen-circle": "\ue20e",
    "fa-pegasus": "\uf703",
    "fa-pedestal": "\ue20d",
    "fa-pear": "\ue20c",
    "fa-peapod": "\ue31c",
    "fa-peanuts": "\ue431",
    "fa-peanut": "\ue430",
    "fa-peach": "\ue20b",
    "fa-peace": "\uf67c",
    "fa-paw-simple": "\uf701",
    "fa-paw-claws": "\uf702",
    "fa-paw": "\uf1b0",
    "fa-paste": "\uf0ea",
    "fa-party-horn": "\ue31b",
    "fa-party-bell": "\ue31a",
    "fa-paragraph-left": "\uf878",
    "fa-paragraph": "\uf1dd",
    "fa-parachute-box": "\uf4cd",
    "fa-paperclip-vertical": "\ue3c2",
    "fa-paper-plane-top": "\ue20a",
    "fa-panorama": "\ue209",
    "fa-panel-fire": "\ue42f",
    "fa-panel-ews": "\ue42e",
    "fa-pancakes": "\ue42d",
    "fa-pan-frying": "\ue42c",
    "fa-pan-food": "\ue42b",
    "fa-pallet-boxes": "\uf483",
    "fa-pallet-box": "\ue208",
    "fa-pallet": "\uf482",
    "fa-paintbrush-pencil": "\ue206",
    "fa-paintbrush-fine": "\uf5a9",
    "fa-paintbrush": "\uf1fc",
    "fa-pager": "\uf815",
    "fa-page-caret-up": "\ue42a",
    "fa-page-caret-down": "\ue429",
    "fa-page": "\ue428",
    "fa-p": "50",
    "fa-overline": "\uf876",
    "fa-oven": "\ue01d",
    "fa-outlet": "\ue01c",
    "fa-outdent": "\uf03b",
    "fa-ornament": "\uf7b8",
    "fa-option": "\ue318",
    "fa-onion": "\ue427",
    "fa-omega": "\uf67a",
    "fa-om": "\uf679",
    "fa-olive-branch": "\ue317",
    "fa-olive": "\ue316",
    "fa-oil-well": "\ue532",
    "fa-oil-temperature": "\uf614",
    "fa-oil-can-drip": "\ue205",
    "fa-oil-can": "\uf613",
    "fa-octagon-xmark": "\uf2f0",
    "fa-octagon-plus": "\uf301",
    "fa-octagon-minus": "\uf308",
    "fa-octagon-exclamation": "\ue204",
    "fa-octagon-divide": "\ue203",
    "fa-octagon-check": "\ue426",
    "fa-octagon": "\uf306",
    "fa-objects-column": "\ue3c1",
    "fa-objects-align-top": "\ue3c0",
    "fa-objects-align-right": "\ue3bf",
    "fa-objects-align-left": "\ue3be",
    "fa-objects-align-center-vertical": "\ue3bd",
    "fa-objects-align-center-horizontal": "\ue3bc",
    "fa-objects-align-bottom": "\ue3bb",
    "fa-object-union": "\ue49f",
    "fa-object-ungroup": "\uf248",
    "fa-object-subtract": "\ue49e",
    "fa-object-intersect": "\ue49d",
    "fa-object-group": "\uf247",
    "fa-object-exclude": "\ue49c",
    "fa-o": "4f",
    "fa-notes": "\ue202",
    "fa-notebook": "\ue201",
    "fa-note-sticky": "\uf249",
    "fa-note-medical": "\ue200",
    "fa-note": "\ue1ff",
    "fa-notdef": "\ue1fe",
    "fa-nose": "\ue5bd",
    "fa-nfc-trash": "\ue1fd",
    "fa-nfc-symbol": "\ue531",
    "fa-nfc-slash": "\ue1fc",
    "fa-nfc-signal": "\ue1fb",
    "fa-nfc-pen": "\ue1fa",
    "fa-nfc-magnifying-glass": "\ue1f9",
    "fa-nfc-lock": "\ue1f8",
    "fa-nfc": "\ue1f7",
    "fa-neuter": "\uf22c",
    "fa-nesting-dolls": "\ue3ba",
    "fa-narwhal": "\uf6fe",
    "fa-naira-sign": "\ue1f6",
    "fa-n": "4e",
    "fa-mustache": "\ue5bc",
    "fa-music-slash": "\uf8d1",
    "fa-music-note-slash": "\uf8d0",
    "fa-music-note": "\uf8cf",
    "fa-music-magnifying-glass": "\ue662",
    "fa-mushroom": "\ue425",
    "fa-mug-tea-saucer": "\ue1f5",
    "fa-mug-marshmallows": "\uf7b7",
    "fa-mug": "\uf874",
    "fa-mp3-player": "\uf8ce",
    "fa-mouse-field": "\ue5a8",
    "fa-mountains": "\uf6fd",
    "fa-mountain-city": "\ue52e",
    "fa-mountain": "\uf6fc",
    "fa-mound": "\ue52d",
    "fa-mosquito-net": "\ue52c",
    "fa-mosquito": "\ue52b",
    "fa-mosque": "\uf678",
    "fa-mortar-pestle": "\uf5a7",
    "fa-moon-over-sun": "\uf74a",
    "fa-moon-cloud": "\uf754",
    "fa-monument": "\uf5a6",
    "fa-monkey": "\uf6fb",
    "fa-monitor-waveform": "\uf611",
    "fa-money-simple-from-bracket": "\ue313",
    "fa-money-from-bracket": "\ue312",
    "fa-money-check-pen": "\uf872",
    "fa-money-check-dollar-pen": "\uf873",
    "fa-money-check-dollar": "\uf53d",
    "fa-money-check": "\uf53c",
    "fa-money-bills-simple": "\ue1f4",
    "fa-money-bills": "\ue1f3",
    "fa-money-bill-wheat": "\ue52a",
    "fa-money-bill-wave": "\uf53a",
    "fa-money-bill-trend-up": "\ue529",
    "fa-money-bill-transfer": "\ue528",
    "fa-money-bill-simple-wave": "\ue1f2",
    "fa-money-bill-simple": "\ue1f1",
    "fa-money-bill-1-wave": "\uf53b",
    "fa-money-bill-1": "\uf3d1",
    "fa-mobile-signal-out": "\ue1f0",
    "fa-mobile-signal": "\ue1ef",
    "fa-mobile-screen-button": "\uf3cd",
    "fa-mobile-screen": "\uf3cf",
    "fa-mobile-retro": "\ue527",
    "fa-mobile-notch": "\ue1ee",
    "fa-mobile-button": "\uf10b",
    "fa-mitten": "\uf7b5",
    "fa-mistletoe": "\uf7b4",
    "fa-minimize": "\uf78c",
    "fa-mill-sign": "\ue1ed",
    "fa-microscope": "\uf610",
    "fa-microphone-stand": "\uf8cb",
    "fa-microphone-lines-slash": "\uf539",
    "fa-microphone-lines": "\uf3c9",
    "fa-microchip-ai": "\ue1ec",
    "fa-meter-fire": "\ue1eb",
    "fa-meter-droplet": "\ue1ea",
    "fa-meter-bolt": "\ue1e9",
    "fa-meter": "\ue1e8",
    "fa-meteor": "\uf753",
    "fa-messages-question": "\ue1e7",
    "fa-messages-dollar": "\uf652",
    "fa-messages": "\uf4b6",
    "fa-message-xmark": "\uf4ab",
    "fa-message-text": "\ue1e6",
    "fa-message-sms": "\ue1e5",
    "fa-message-smile": "\uf4aa",
    "fa-message-slash": "\uf4a9",
    "fa-message-quote": "\ue1e4",
    "fa-message-question": "\ue1e3",
    "fa-message-plus": "\uf4a8",
    "fa-message-pen": "\uf4a4",
    "fa-message-music": "\uf8af",
    "fa-message-minus": "\uf4a7",
    "fa-message-middle-top": "\ue1e2",
    "fa-message-middle": "\ue1e1",
    "fa-message-medical": "\uf7f4",
    "fa-message-lines": "\uf4a6",
    "fa-message-image": "\ue1e0",
    "fa-message-heart": "\ue5c9",
    "fa-message-exclamation": "\uf4a5",
    "fa-message-dots": "\uf4a3",
    "fa-message-dollar": "\uf650",
    "fa-message-code": "\ue1df",
    "fa-message-check": "\uf4a2",
    "fa-message-captions": "\ue1de",
    "fa-message-bot": "\ue3b8",
    "fa-message-arrow-up-right": "\ue1dd",
    "fa-message-arrow-up": "\ue1dc",
    "fa-message-arrow-down": "\ue1db",
    "fa-message": "\uf27a",
    "fa-merge": "\ue526",
    "fa-mercury": "\uf223",
    "fa-menorah": "\uf676",
    "fa-memory": "\uf538",
    "fa-memo-pad": "\ue1da",
    "fa-memo-circle-info": "\ue49a",
    "fa-memo-circle-check": "\ue1d9",
    "fa-memo": "\ue1d8",
    "fa-melon-slice": "\ue311",
    "fa-melon": "\ue310",
    "fa-maximize": "\uf31e",
    "fa-mattress-pillow": "\ue525",
    "fa-masks-theater": "\uf630",
    "fa-mask-ventilator": "\ue524",
    "fa-mask-snorkel": "\ue3b7",
    "fa-mask-face": "\ue1d7",
    "fa-martini-glass-empty": "\uf000",
    "fa-martini-glass-citrus": "\uf561",
    "fa-martini-glass": "\uf57b",
    "fa-mars-stroke-up": "\uf22a",
    "fa-mars-stroke-right": "\uf22b",
    "fa-mars-stroke": "\uf229",
    "fa-mars-double": "\uf227",
    "fa-mars-and-venus-burst": "\ue523",
    "fa-mars-and-venus": "\uf224",
    "fa-mars": "\uf222",
    "fa-map-pin": "\uf276",
    "fa-map-location-dot": "\uf5a0",
    "fa-map-location": "\uf59f",
    "fa-map": "\uf279",
    "fa-manhole": "\ue1d6",
    "fa-mango": "\ue30f",
    "fa-mandolin": "\uf6f9",
    "fa-manat-sign": "\ue1d5",
    "fa-mailbox-flag-up": "\ue5bb",
    "fa-magnifying-glass-waveform": "\ue661",
    "fa-magnifying-glass-plus": "\uf00e",
    "fa-magnifying-glass-play": "\ue660",
    "fa-magnifying-glass-music": "\ue65f",
    "fa-magnifying-glass-minus": "\uf010",
    "fa-magnifying-glass-location": "\uf689",
    "fa-magnifying-glass-dollar": "\uf688",
    "fa-magnifying-glass-chart": "\ue522",
    "fa-magnifying-glass-arrows-rotate": "\ue65e",
    "fa-magnifying-glass-arrow-right": "\ue521",
    "fa-mace": "\uf6f8",
    "fa-m": "4d",
    "fa-lungs-virus": "\ue067",
    "fa-lungs": "\uf604",
    "fa-luchador-mask": "\uf455",
    "fa-lollipop": "\ue424",
    "fa-locust": "\ue520",
    "fa-lock-open": "\uf3c1",
    "fa-lock-keyhole-open": "\uf3c2",
    "fa-lock-keyhole": "\uf30d",
    "fa-lock-hashtag": "\ue423",
    "fa-lock-a": "\ue422",
    "fa-location-xmark": "\uf60e",
    "fa-location-smile": "\uf60d",
    "fa-location-question": "\uf60b",
    "fa-location-plus": "\uf60a",
    "fa-location-pin-slash": "\uf60c",
    "fa-location-pin-lock": "\ue51f",
    "fa-location-pen": "\uf607",
    "fa-location-minus": "\uf609",
    "fa-location-exclamation": "\uf608",
    "fa-location-dot-slash": "\uf605",
    "fa-location-crosshairs-slash": "\uf603",
    "fa-location-crosshairs": "\uf601",
    "fa-location-check": "\uf606",
    "fa-location-arrow-up": "\ue63a",
    "fa-location-arrow": "\uf124",
    "fa-lobster": "\ue421",
    "fa-loader": "\ue1d4",
    "fa-litecoin-sign": "\ue1d3",
    "fa-list-ul": "\uf0ca",
    "fa-list-tree": "\ue1d2",
    "fa-list-timeline": "\ue1d1",
    "fa-list-radio": "\ue1d0",
    "fa-list-ol": "\uf0cb",
    "fa-list-music": "\uf8c9",
    "fa-list-dropdown": "\ue1cf",
    "fa-list-check": "\uf0ae",
    "fa-lira-sign": "\uf195",
    "fa-lips": "\uf600",
    "fa-link-slash": "\uf127",
    "fa-link-simple-slash": "\ue1ce",
    "fa-link-simple": "\ue1cd",
    "fa-link-horizontal-slash": "\ue1cc",
    "fa-link-horizontal": "\ue1cb",
    "fa-lines-leaning": "\ue51e",
    "fa-line-columns": "\uf870",
    "fa-lighthouse": "\ue612",
    "fa-lightbulb-on": "\uf672",
    "fa-lightbulb-gear": "\ue5fd",
    "fa-lightbulb-exclamation-on": "\ue1ca",
    "fa-lightbulb-exclamation": "\uf671",
    "fa-lightbulb-dollar": "\uf670",
    "fa-lightbulb-cfl-on": "\ue5a7",
    "fa-lightbulb-cfl": "\ue5a6",
    "fa-light-switch-on": "\ue019",
    "fa-light-switch-off": "\ue018",
    "fa-light-emergency-on": "\ue420",
    "fa-light-emergency": "\ue41f",
    "fa-light-ceiling": "\ue016",
    "fa-life-ring": "\uf1cd",
    "fa-less-than-equal": "\uf537",
    "fa-less-than": "3c",
    "fa-left-to-line": "\uf34b",
    "fa-left-to-bracket": "\ue66d",
    "fa-left-right": "\uf337",
    "fa-left-long-to-line": "\ue41e",
    "fa-left-long": "\uf30a",
    "fa-left-from-line": "\uf348",
    "fa-left-from-bracket": "\ue66c",
    "fa-left": "\uf355",
    "fa-leafy-green": "\ue41d",
    "fa-leaf-oak": "\uf6f7",
    "fa-leaf-maple": "\uf6f6",
    "fa-leaf-heart": "\uf4cb",
    "fa-layer-plus": "\uf5ff",
    "fa-layer-minus": "\uf5fe",
    "fa-lasso-sparkles": "\ue1c9",
    "fa-lasso": "\uf8c8",
    "fa-lari-sign": "\ue1c8",
    "fa-laptop-slash": "\ue1c7",
    "fa-laptop-mobile": "\uf87a",
    "fa-laptop-medical": "\uf812",
    "fa-laptop-file": "\ue51d",
    "fa-laptop-code": "\uf5fc",
    "fa-laptop-binary": "\ue5e7",
    "fa-laptop-arrow-down": "\ue1c6",
    "fa-landmark-magnifying-glass": "\ue622",
    "fa-landmark-flag": "\ue51c",
    "fa-landmark-dome": "\uf752",
    "fa-land-mine-on": "\ue51b",
    "fa-lamp-street": "\ue1c5",
    "fa-lamp-floor": "\ue015",
    "fa-lamp-desk": "\ue014",
    "fa-lambda": "\uf66e",
    "fa-lacrosse-stick-ball": "\ue3b6",
    "fa-lacrosse-stick": "\ue3b5",
    "fa-l": "4c",
    "fa-knife": "\uf2e4",
    "fa-kiwi-fruit": "\ue30c",
    "fa-kite": "\uf6f4",
    "fa-kitchen-set": "\ue51a",
    "fa-kit-medical": "\uf479",
    "fa-kip-sign": "\ue1c4",
    "fa-khanda": "\uf66d",
    "fa-keynote": "\uf66c",
    "fa-keyboard-left": "\ue1c3",
    "fa-keyboard-down": "\ue1c2",
    "fa-keyboard-brightness-low": "\ue1c1",
    "fa-keyboard-brightness": "\ue1c0",
    "fa-key-skeleton-left-right": "\ue3b4",
    "fa-key-skeleton": "\uf6f3",
    "fa-kerning": "\uf86f",
    "fa-kazoo": "\uf8c7",
    "fa-kaaba": "\uf66b",
    "fa-k": "4b",
    "fa-jug-detergent": "\ue519",
    "fa-jug-bottle": "\ue5fb",
    "fa-jug": "\uf8c6",
    "fa-jet-fighter-up": "\ue518",
    "fa-jet-fighter": "\uf0fb",
    "fa-jedi": "\uf669",
    "fa-jar-wheat": "\ue517",
    "fa-jar": "\ue516",
    "fa-jack-o-lantern": "\uf30e",
    "fa-j": "4a",
    "fa-italic": "\uf033",
    "fa-island-tropical": "\uf811",
    "fa-intersection": "\uf668",
    "fa-interrobang": "\ue5ba",
    "fa-integral": "\uf667",
    "fa-input-text": "\ue1bf",
    "fa-input-pipe": "\ue1be",
    "fa-input-numeric": "\ue1bd",
    "fa-inhaler": "\uf5f9",
    "fa-infinity": "\uf534",
    "fa-industry-windows": "\uf3b3",
    "fa-indian-rupee-sign": "\ue1bc",
    "fa-indent": "\uf03c",
    "fa-inboxes": "\ue1bb",
    "fa-inbox-out": "\uf311",
    "fa-inbox-in": "\uf310",
    "fa-inbox-full": "\ue1ba",
    "fa-images-user": "\ue1b9",
    "fa-image-user": "\ue1b8",
    "fa-image-slash": "\ue1b7",
    "fa-image-portrait": "\uf3e0",
    "fa-image-polaroid-user": "\ue1b6",
    "fa-image-polaroid": "\uf8c4",
    "fa-image-landscape": "\ue1b5",
    "fa-igloo": "\uf7ae",
    "fa-id-card-clip": "\uf47f",
    "fa-id-card": "\uf2c2",
    "fa-id-badge": "\uf2c1",
    "fa-icicles": "\uf7ad",
    "fa-ice-skate": "\uf7ac",
    "fa-ice-cream": "\uf810",
    "fa-i": "49",
    "fa-hyphen": "\u002d",
    "fa-hurricane": "\uf751",
    "fa-hundred-points": "\ue41c",
    "fa-hryvnia-sign": "\uf6f2",
    "fa-house-window": "\ue3b3",
    "fa-house-water": "\uf74f",
    "fa-house-user": "\ue1b0",
    "fa-house-turret": "\ue1b4",
    "fa-house-tsunami": "\ue515",
    "fa-house-tree": "\ue1b3",
    "fa-house-signal": "\ue012",
    "fa-house-person-return": "\ue011",
    "fa-house-person-leave": "\ue00f",
    "fa-house-medical-flag": "\ue514",
    "fa-house-medical-circle-xmark": "\ue513",
    "fa-house-medical-circle-exclamation": "\ue512",
    "fa-house-medical-circle-check": "\ue511",
    "fa-house-medical": "\ue3b2",
    "fa-house-lock": "\ue510",
    "fa-house-laptop": "\ue066",
    "fa-house-heart": "\uf4c9",
    "fa-house-flood-water-circle-arrow-right": "\ue50f",
    "fa-house-flood-water": "\ue50e",
    "fa-house-flag": "\ue50d",
    "fa-house-fire": "\ue50c",
    "fa-house-day": "\ue00e",
    "fa-house-crack": "\ue3b1",
    "fa-house-circle-xmark": "\ue50b",
    "fa-house-circle-exclamation": "\ue50a",
    "fa-house-circle-check": "\ue509",
    "fa-house-chimney-window": "\ue00d",
    "fa-house-chimney-user": "\ue065",
    "fa-house-chimney-medical": "\uf7f2",
    "fa-house-chimney-heart": "\ue1b2",
    "fa-house-chimney-crack": "\uf6f1",
    "fa-house-chimney-blank": "\ue3b0",
    "fa-house-chimney": "\ue3af",
    "fa-house-building": "\ue1b1",
    "fa-house-blank": "\ue487",
    "fa-hourglass-half": "\uf252",
    "fa-hourglass-end": "\uf253",
    "fa-hourglass-clock": "\ue41b",
    "fa-hourglass": "\uf254",
    "fa-hotdog": "\uf80f",
    "fa-hot-tub-person": "\uf593",
    "fa-hospitals": "\uf80e",
    "fa-hospital-user": "\uf80d",
    "fa-hose-reel": "\ue41a",
    "fa-hose": "\ue419",
    "fa-horse-saddle": "\uf8c3",
    "fa-horse-head": "\uf7ab",
    "fa-horse": "\uf6f0",
    "fa-horizontal-rule": "\uf86c",
    "fa-hood-cloak": "\uf6ef",
    "fa-honey-pot": "\ue418",
    "fa-holly-berry": "\uf7aa",
    "fa-hockey-sticks": "\uf454",
    "fa-hockey-stick-puck": "\ue3ae",
    "fa-hockey-puck": "\uf453",
    "fa-hockey-mask": "\uf6ee",
    "fa-hill-rockslide": "\ue508",
    "fa-hill-avalanche": "\ue507",
    "fa-highlighter-line": "\ue1af",
    "fa-highlighter": "\uf591",
    "fa-high-definition": "\ue1ae",
    "fa-hexagon-xmark": "\uf2ee",
    "fa-hexagon-vertical-nft-slanted": "\ue506",
    "fa-hexagon-vertical-nft": "\ue505",
    "fa-hexagon-plus": "\uf300",
    "fa-hexagon-minus": "\uf307",
    "fa-hexagon-image": "\ue504",
    "fa-hexagon-exclamation": "\ue417",
    "fa-hexagon-divide": "\ue1ad",
    "fa-hexagon-check": "\ue416",
    "fa-hexagon": "\uf312",
    "fa-helmet-un": "\ue503",
    "fa-helmet-safety": "\uf807",
    "fa-helmet-battle": "\uf6eb",
    "fa-helicopter-symbol": "\ue502",
    "fa-helicopter": "\uf533",
    "fa-heat": "\ue00c",
    "fa-heart-pulse": "\uf21e",
    "fa-heart-half-stroke": "\ue1ac",
    "fa-heart-half": "\ue1ab",
    "fa-heart-crack": "\uf7a9",
    "fa-heart-circle-xmark": "\ue501",
    "fa-heart-circle-plus": "\ue500",
    "fa-heart-circle-minus": "\ue4ff",
    "fa-heart-circle-exclamation": "\ue4fe",
    "fa-heart-circle-check": "\ue4fd",
    "fa-heart-circle-bolt": "\ue4fc",
    "fa-headphones-simple": "\uf58f",
    "fa-head-side-virus": "\ue064",
    "fa-head-side-medical": "\uf809",
    "fa-head-side-mask": "\ue063",
    "fa-head-side-heart": "\ue1aa",
    "fa-head-side-headphones": "\uf8c2",
    "fa-head-side-goggles": "\uf6ea",
    "fa-head-side-gear": "\ue611",
    "fa-head-side-cough-slash": "\ue062",
    "fa-head-side-cough": "\ue061",
    "fa-head-side-brain": "\uf808",
    "fa-hat-wizard": "\uf6e8",
    "fa-hat-witch": "\uf6e7",
    "fa-hat-winter": "\uf7a8",
    "fa-hat-santa": "\uf7a7",
    "fa-hat-cowboy-side": "\uf8c1",
    "fa-hat-cowboy": "\uf8c0",
    "fa-hat-chef": "\uf86b",
    "fa-hat-beach": "\ue606",
    "fa-hashtag-lock": "\ue415",
    "fa-hard-drive": "\uf0a0",
    "fa-hanukiah": "\uf6e6",
    "fa-handshake-simple-slash": "\ue05f",
    "fa-handshake-simple": "\uf4c6",
    "fa-handshake-angle": "\uf4c4",
    "fa-hands-praying": "\uf684",
    "fa-hands-holding-heart": "\uf4c3",
    "fa-hands-holding-dollar": "\uf4c5",
    "fa-hands-holding-diamond": "\uf47c",
    "fa-hands-holding-circle": "\ue4fb",
    "fa-hands-holding-child": "\ue4fa",
    "fa-hands-holding": "\uf4c2",
    "fa-hands-clapping": "\ue1a8",
    "fa-hands-bubbles": "\ue05e",
    "fa-hands-bound": "\ue4f9",
    "fa-hands-asl-interpreting": "\uf2a3",
    "fa-handcuffs": "\ue4f8",
    "fa-hand-wave": "\ue1a7",
    "fa-hand-spock": "\uf259",
    "fa-hand-sparkles": "\ue05d",
    "fa-hand-scissors": "\uf257",
    "fa-hand-pointer": "\uf25a",
    "fa-hand-point-right": "\uf0a4",
    "fa-hand-point-ribbon": "\ue1a6",
    "fa-hand-point-left": "\uf0a5",
    "fa-hand-point-down": "\uf0a7",
    "fa-hand-peace": "\uf25b",
    "fa-hand-middle-finger": "\uf806",
    "fa-hand-love": "\ue1a5",
    "fa-hand-lizard": "\uf258",
    "fa-hand-horns": "\ue1a9",
    "fa-hand-holding-skull": "\ue1a4",
    "fa-hand-holding-seedling": "\uf4bf",
    "fa-hand-holding-medical": "\ue05c",
    "fa-hand-holding-magic": "\uf6e5",
    "fa-hand-holding-hand": "\ue4f7",
    "fa-hand-holding-droplet": "\uf4c1",
    "fa-hand-holding-dollar": "\uf4c0",
    "fa-hand-holding-circle-dollar": "\ue621",
    "fa-hand-holding-box": "\uf47b",
    "fa-hand-holding": "\uf4bd",
    "fa-hand-heart": "\uf4bc",
    "fa-hand-fist": "\uf6de",
    "fa-hand-fingers-crossed": "\ue1a3",
    "fa-hand-dots": "\uf461",
    "fa-hand-back-point-up": "\ue1a2",
    "fa-hand-back-point-right": "\ue1a1",
    "fa-hand-back-point-ribbon": "\ue1a0",
    "fa-hand-back-point-left": "\ue19f",
    "fa-hand-back-point-down": "\ue19e",
    "fa-hand-back-fist": "\uf255",
    "fa-hamsa": "\uf665",
    "fa-hammer-war": "\uf6e4",
    "fa-hammer-crash": "\ue414",
    "fa-hammer-brush": "\ue620",
    "fa-h6": "\ue413",
    "fa-h5": "\ue412",
    "fa-h4": "\uf86a",
    "fa-h3": "\uf315",
    "fa-h2": "\uf314",
    "fa-h1": "\uf313",
    "fa-h": "48",
    "fa-gun-squirt": "\ue19d",
    "fa-gun-slash": "\ue19c",
    "fa-gun": "\ue19b",
    "fa-guitars": "\uf8bf",
    "fa-guitar-electric": "\uf8be",
    "fa-guitar": "\uf7a6",
    "fa-guarani-sign": "\ue19a",
    "fa-group-arrows-rotate": "\ue4f6",
    "fa-grip-vertical": "\uf58e",
    "fa-grip-lines-vertical": "\uf7a5",
    "fa-grip-lines": "\uf7a4",
    "fa-grip-dots-vertical": "\ue411",
    "fa-grip-dots": "\ue410",
    "fa-grip": "\uf58d",
    "fa-grill-fire": "\ue5a4",
    "fa-grill": "\ue5a3",
    "fa-grid-round-5": "\ue5de",
    "fa-grid-round-4": "\ue5dd",
    "fa-grid-round-2-plus": "\ue5dc",
    "fa-grid-round-2": "\ue5db",
    "fa-grid-round": "\ue5da",
    "fa-grid-horizontal": "\ue307",
    "fa-grid-dividers": "\ue3ad",
    "fa-grid-5": "\ue199",
    "fa-grid-4": "\ue198",
    "fa-grid-2-plus": "\ue197",
    "fa-grid": "\ue195",
    "fa-greater-than-equal": "\uf532",
    "fa-greater-than": "3e",
    "fa-grate-droplet": "\ue194",
    "fa-grate": "\ue193",
    "fa-grapes": "\ue306",
    "fa-gramophone": "\uf8bd",
    "fa-graduation-cap": "\uf19d",
    "fa-golf-flag-hole": "\ue3ac",
    "fa-golf-club": "\uf451",
    "fa-golf-ball-tee": "\uf450",
    "fa-goal-net": "\ue3ab",
    "fa-globe-snow": "\uf7a3",
    "fa-globe-pointer": "\ue60e",
    "fa-glasses-round": "\uf5f5",
    "fa-glass-water-droplet": "\ue4f5",
    "fa-glass-water": "\ue4f4",
    "fa-glass-half": "\ue192",
    "fa-glass-empty": "\ue191",
    "fa-glass-citrus": "\uf869",
    "fa-gingerbread-man": "\uf79d",
    "fa-gifts": "\uf79c",
    "fa-gift-card": "\uf663",
    "fa-gif": "\ue190",
    "fa-genderless": "\uf22d",
    "fa-gem": "\uf3a5",
    "fa-gear-complex-code": "\ue5eb",
    "fa-gear-complex": "\ue5e9",
    "fa-gear-code": "\ue5e8",
    "fa-gavel": "\uf0e3",
    "fa-gauge-simple-min": "\uf62d",
    "fa-gauge-simple-max": "\uf62b",
    "fa-gauge-simple-low": "\uf62c",
    "fa-gauge-simple-high": "\uf62a",
    "fa-gauge-simple": "\uf629",
    "fa-gauge-min": "\uf628",
    "fa-gauge-max": "\uf626",
    "fa-gauge-low": "\uf627",
    "fa-gauge-high": "\uf625",
    "fa-gauge-circle-plus": "\ue498",
    "fa-gauge-circle-minus": "\ue497",
    "fa-gauge-circle-bolt": "\ue496",
    "fa-gas-pump-slash": "\uf5f4",
    "fa-gas-pump": "\uf52f",
    "fa-garlic": "\ue40e",
    "fa-garage-open": "\ue00b",
    "fa-garage-car": "\ue00a",
    "fa-garage": "\ue009",
    "fa-gamepad-modern": "\ue5a2",
    "fa-game-console-handheld-crank": "\ue5b9",
    "fa-game-board-simple": "\uf868",
    "fa-game-board": "\uf867",
    "fa-gallery-thumbnails": "\ue3aa",
    "fa-galaxy": "\ue008",
    "fa-g": "47",
    "fa-futbol": "\uf1e3",
    "fa-function": "\uf661",
    "fa-frog": "\uf52e",
    "fa-french-fries": "\uf803",
    "fa-franc-sign": "\ue18f",
    "fa-frame": "\ue495",
    "fa-forward-step": "\uf051",
    "fa-forward-fast": "\uf050",
    "fa-forklift": "\uf47a",
    "fa-fork-knife": "\uf2e6",
    "fa-fork": "\uf2e3",
    "fa-football-helmet": "\uf44f",
    "fa-football": "\uf44e",
    "fa-font-awesome": "\uf2b4",
    "fa-fondue-pot": "\ue40d",
    "fa-folders": "\uf660",
    "fa-folder-xmark": "\uf65f",
    "fa-folder-user": "\ue18e",
    "fa-folder-tree": "\uf802",
    "fa-folder-plus": "\uf65e",
    "fa-folder-music": "\ue18d",
    "fa-folder-minus": "\uf65d",
    "fa-folder-medical": "\ue18c",
    "fa-folder-magnifying-glass": "\ue18b",
    "fa-folder-image": "\ue18a",
    "fa-folder-heart": "\ue189",
    "fa-folder-grid": "\ue188",
    "fa-folder-gear": "\ue187",
    "fa-folder-closed": "\ue185",
    "fa-folder-check": "\ue64e",
    "fa-folder-bookmark": "\ue186",
    "fa-folder-arrow-up": "\ue054",
    "fa-folder-arrow-down": "\ue053",
    "fa-flying-disc": "\ue3a9",
    "fa-flux-capacitor": "\uf8ba",
    "fa-flute": "\uf8b9",
    "fa-flower-daffodil": "\uf800",
    "fa-florin-sign": "\ue184",
    "fa-floppy-disks": "\ue183",
    "fa-floppy-disk-pen": "\ue182",
    "fa-floppy-disk-circle-xmark": "\ue181",
    "fa-floppy-disk-circle-arrow-right": "\ue180",
    "fa-floppy-disk": "\uf0c7",
    "fa-flatbread-stuffed": "\ue40c",
    "fa-flatbread": "\ue40b",
    "fa-flask-vial": "\ue4f3",
    "fa-flask-round-potion": "\uf6e1",
    "fa-flask-round-poison": "\uf6e0",
    "fa-flask-gear": "\ue5f1",
    "fa-flashlight": "\uf8b8",
    "fa-flag-usa": "\uf74d",
    "fa-flag-swallowtail": "\uf74c",
    "fa-flag-pennant": "\uf456",
    "fa-fishing-rod": "\ue3a8",
    "fa-fish-fins": "\ue4f2",
    "fa-fish-cooked": "\uf7fe",
    "fa-fish-bones": "\ue304",
    "fa-fireplace": "\uf79a",
    "fa-fire-smoke": "\uf74b",
    "fa-fire-hydrant": "\ue17f",
    "fa-fire-flame-simple": "\uf46a",
    "fa-fire-flame-curved": "\uf7e4",
    "fa-fire-flame": "\uf6df",
    "fa-fire-extinguisher": "\uf134",
    "fa-fire-burner": "\ue4f1",
    "fa-filters": "\ue17e",
    "fa-filter-slash": "\ue17d",
    "fa-filter-list": "\ue17c",
    "fa-filter-circle-xmark": "\ue17b",
    "fa-filter-circle-dollar": "\uf662",
    "fa-films": "\ue17a",
    "fa-film-slash": "\ue179",
    "fa-film-simple": "\uf3a0",
    "fa-film-canister": "\uf8b7",
    "fa-fill-drip": "\uf576",
    "fa-fill": "\uf575",
    "fa-files-medical": "\uf7fd",
    "fa-file-zipper": "\uf1c6",
    "fa-file-zip": "\ue5ee",
    "fa-file-xml": "\ue654",
    "fa-file-xmark": "\uf317",
    "fa-file-xls": "\ue64d",
    "fa-file-waveform": "\uf478",
    "fa-file-video": "\uf1c8",
    "fa-file-vector": "\ue64c",
    "fa-file-user": "\uf65c",
    "fa-file-svg": "\ue64b",
    "fa-file-slash": "\ue3a7",
    "fa-file-signature": "\uf573",
    "fa-file-shield": "\ue4f0",
    "fa-file-prescription": "\uf572",
    "fa-file-ppt": "\ue64a",
    "fa-file-powerpoint": "\uf1c4",
    "fa-file-png": "\ue666",
    "fa-file-plus-minus": "\ue177",
    "fa-file-plus": "\uf319",
    "fa-file-pen": "\uf31c",
    "fa-file-music": "\uf8b6",
    "fa-file-mp4": "\ue649",
    "fa-file-mp3": "\ue648",
    "fa-file-mov": "\ue647",
    "fa-file-minus": "\uf318",
    "fa-file-medical": "\uf477",
    "fa-file-magnifying-glass": "\uf865",
    "fa-file-lock": "\ue3a6",
    "fa-file-lines": "\uf15c",
    "fa-file-jpg": "\ue646",
    "fa-file-invoice-dollar": "\uf571",
    "fa-file-image": "\uf1c5",
    "fa-file-heart": "\ue176",
    "fa-file-gif": "\ue645",
    "fa-file-eps": "\ue644",
    "fa-file-doc": "\ue5ed",
    "fa-file-dashed-line": "\uf877",
    "fa-file-csv": "\uf6dd",
    "fa-file-code": "\uf1c9",
    "fa-file-circle-xmark": "\ue5a1",
    "fa-file-circle-question": "\ue4ef",
    "fa-file-circle-plus": "\ue494",
    "fa-file-circle-minus": "\ue4ed",
    "fa-file-circle-info": "\ue493",
    "fa-file-circle-exclamation": "\ue4eb",
    "fa-file-circle-check": "\ue5a0",
    "fa-file-chart-pie": "\uf65a",
    "fa-file-chart-column": "\uf659",
    "fa-file-certificate": "\uf5f3",
    "fa-file-cad": "\ue672",
    "fa-file-binary": "\ue175",
    "fa-file-audio": "\uf1c7",
    "fa-file-arrow-up": "\uf574",
    "fa-file-arrow-down": "\uf56d",
    "fa-field-hockey-stick-ball": "\uf44c",
    "fa-ferry": "\ue4ea",
    "fa-ferris-wheel": "\ue174",
    "fa-fence": "\ue303",
    "fa-feather-pointed": "\uf56b",
    "fa-fax": "\uf1ac",
    "fa-faucet-drip": "\ue006",
    "fa-faucet": "\ue005",
    "fa-farm": "\uf864",
    "fa-fan-table": "\ue004",
    "fa-fan": "\uf863",
    "fa-family-pants": "\ue302",
    "fa-family-dress": "\ue301",
    "fa-family": "\ue300",
    "fa-falafel": "\ue40a",
    "fa-face-zipper": "\ue3a5",
    "fa-face-zany": "\ue3a4",
    "fa-face-worried": "\ue3a3",
    "fa-face-woozy": "\ue3a2",
    "fa-face-weary": "\ue3a1",
    "fa-face-viewfinder": "\ue2ff",
    "fa-face-unamused": "\ue39f",
    "fa-face-tongue-sweat": "\ue39e",
    "fa-face-tongue-money": "\ue39d",
    "fa-face-tissue": "\ue39c",
    "fa-face-tired": "\uf5c8",
    "fa-face-thinking": "\ue39b",
    "fa-face-thermometer": "\ue39a",
    "fa-face-swear": "\ue399",
    "fa-face-surprise": "\uf5c2",
    "fa-face-sunglasses": "\ue398",
    "fa-face-spiral-eyes": "\ue485",
    "fa-face-smirking": "\ue397",
    "fa-face-smiling-hands": "\ue396",
    "fa-face-smile-wink": "\uf4da",
    "fa-face-smile-upside-down": "\ue395",
    "fa-face-smile-tongue": "\ue394",
    "fa-face-smile-tear": "\ue393",
    "fa-face-smile-relaxed": "\ue392",
    "fa-face-smile-plus": "\uf5b9",
    "fa-face-smile-horns": "\ue391",
    "fa-face-smile-hearts": "\ue390",
    "fa-face-smile-halo": "\ue38f",
    "fa-face-smile-beam": "\uf5b8",
    "fa-face-sleepy": "\ue38e",
    "fa-face-sleeping": "\ue38d",
    "fa-face-shush": "\ue38c",
    "fa-face-scream": "\ue38b",
    "fa-face-saluting": "\ue484",
    "fa-face-sad-tear": "\uf5b4",
    "fa-face-sad-sweat": "\ue38a",
    "fa-face-sad-cry": "\uf5b3",
    "fa-face-rolling-eyes": "\uf5a5",
    "fa-face-relieved": "\ue389",
    "fa-face-raised-eyebrow": "\ue388",
    "fa-face-pouting": "\ue387",
    "fa-face-pleading": "\ue386",
    "fa-face-persevering": "\ue385",
    "fa-face-pensive": "\ue384",
    "fa-face-party": "\ue383",
    "fa-face-nose-steam": "\ue382",
    "fa-face-nauseated": "\ue381",
    "fa-face-monocle": "\ue380",
    "fa-face-melting": "\ue483",
    "fa-face-meh-blank": "\uf5a4",
    "fa-face-meh": "\uf11a",
    "fa-face-mask": "\ue37f",
    "fa-face-lying": "\ue37e",
    "fa-face-laugh-wink": "\uf59c",
    "fa-face-laugh-squint": "\uf59b",
    "fa-face-laugh-beam": "\uf59a",
    "fa-face-laugh": "\uf599",
    "fa-face-kiss-wink-heart": "\uf598",
    "fa-face-kiss-closed-eyes": "\ue37d",
    "fa-face-kiss-beam": "\uf597",
    "fa-face-kiss": "\uf596",
    "fa-face-icicles": "\ue37c",
    "fa-face-hushed": "\ue37b",
    "fa-face-holding-back-tears": "\ue482",
    "fa-face-head-bandage": "\ue37a",
    "fa-face-hand-yawn": "\ue379",
    "fa-face-hand-peeking": "\ue481",
    "fa-face-hand-over-mouth": "\ue378",
    "fa-face-grin-wink": "\uf58c",
    "fa-face-grin-wide": "\uf581",
    "fa-face-grin-tongue-wink": "\uf58b",
    "fa-face-grin-tongue-squint": "\uf58a",
    "fa-face-grin-tongue": "\uf589",
    "fa-face-grin-tears": "\uf588",
    "fa-face-grin-stars": "\uf587",
    "fa-face-grin-squint-tears": "\uf586",
    "fa-face-grin-squint": "\uf585",
    "fa-face-grin-hearts": "\uf584",
    "fa-face-grin-beam-sweat": "\uf583",
    "fa-face-grin-beam": "\uf582",
    "fa-face-grin": "\uf580",
    "fa-face-grimace": "\uf57f",
    "fa-face-glasses": "\ue377",
    "fa-face-frown-slight": "\ue376",
    "fa-face-frown-open": "\uf57a",
    "fa-face-frown": "\uf119",
    "fa-face-flushed": "\uf579",
    "fa-face-fearful": "\ue375",
    "fa-face-eyes-xmarks": "\ue374",
    "fa-face-expressionless": "\ue373",
    "fa-face-explode": "\ue2fe",
    "fa-face-exhaling": "\ue480",
    "fa-face-drooling": "\ue372",
    "fa-face-downcast-sweat": "\ue371",
    "fa-face-dotted": "\ue47f",
    "fa-face-dizzy": "\uf567",
    "fa-face-disguise": "\ue370",
    "fa-face-disappointed": "\ue36f",
    "fa-face-diagonal-mouth": "\ue47e",
    "fa-face-cowboy-hat": "\ue36e",
    "fa-face-confused": "\ue36d",
    "fa-face-confounded": "\ue36c",
    "fa-face-clouds": "\ue47d",
    "fa-face-beam-hand-over-mouth": "\ue47c",
    "fa-face-astonished": "\ue36b",
    "fa-face-anxious-sweat": "\ue36a",
    "fa-face-anguished": "\ue369",
    "fa-face-angry-horns": "\ue368",
    "fa-face-angry": "\uf556",
    "fa-f": "46",
    "fa-eyes": "\ue367",
    "fa-eye-low-vision": "\uf2a8",
    "fa-eye-evil": "\uf6db",
    "fa-eye-dropper-half": "\ue173",
    "fa-eye-dropper-full": "\ue172",
    "fa-eye-dropper": "\uf1fb",
    "fa-explosion": "\ue4e9",
    "fa-expand-wide": "\uf320",
    "fa-excavator": "\ue656",
    "fa-euro-sign": "\uf153",
    "fa-ethernet": "\uf796",
    "fa-escalator": "\ue171",
    "fa-equals": "3d",
    "fa-envelopes-bulk": "\uf674",
    "fa-envelope-open-text": "\uf658",
    "fa-envelope-open-dollar": "\uf657",
    "fa-envelope-open": "\uf2b6",
    "fa-envelope-dot": "\ue16f",
    "fa-envelope-circle-check": "\ue4e8",
    "fa-engine": "\ue16e",
    "fa-ellipsis-vertical": "\uf142",
    "fa-ellipsis-stroke-vertical": "\uf39c",
    "fa-ellipsis-stroke": "\uf39b",
    "fa-ellipsis": "\uf141",
    "fa-elevator": "\ue16d",
    "fa-elephant": "\uf6da",
    "fa-eject": "\uf052",
    "fa-eggplant": "\ue16c",
    "fa-egg-fried": "\uf7fc",
    "fa-egg": "\uf7fb",
    "fa-eclipse": "\uf749",
    "fa-earth-oceania": "\ue47b",
    "fa-earth-europe": "\uf7a2",
    "fa-earth-asia": "\uf57e",
    "fa-earth-africa": "\uf57c",
    "fa-ear-muffs": "\uf795",
    "fa-ear-listen": "\uf2a2",
    "fa-ear-deaf": "\uf2a4",
    "fa-ear": "\uf5f0",
    "fa-e": "45",
    "fa-dungeon": "\uf6d9",
    "fa-dumpster": "\uf793",
    "fa-duck": "\uf6d8",
    "fa-dryer-heat": "\uf862",
    "fa-dryer": "\uf861",
    "fa-drumstick-bite": "\uf6d7",
    "fa-drumstick": "\uf6d6",
    "fa-drum-steelpan": "\uf56a",
    "fa-drum": "\uf569",
    "fa-droplet-slash": "\uf5c7",
    "fa-droplet-percent": "\uf750",
    "fa-droplet-degree": "\uf748",
    "fa-drone-front": "\uf860",
    "fa-drone": "\uf85f",
    "fa-dreidel": "\uf792",
    "fa-draw-polygon": "\uf5ee",
    "fa-draw-circle": "\uf5ed",
    "fa-down-to-line": "\uf34a",
    "fa-down-to-dotted-line": "\ue408",
    "fa-down-to-bracket": "\ue4e7",
    "fa-down-right": "\ue16b",
    "fa-down-long": "\uf309",
    "fa-down-left-and-up-right-to-center": "\uf422",
    "fa-down-left": "\ue16a",
    "fa-down-from-line": "\uf349",
    "fa-down-from-dotted-line": "\ue407",
    "fa-down-from-bracket": "\ue66b",
    "fa-down": "\uf354",
    "fa-dove": "\uf4ba",
    "fa-door-closed": "\uf52a",
    "fa-donut": "\ue406",
    "fa-dong-sign": "\ue169",
    "fa-dolly-empty": "\uf473",
    "fa-dolly": "\uf472",
    "fa-dog-leashed": "\uf6d4",
    "fa-dog": "\uf6d3",
    "fa-do-not-enter": "\uf5ec",
    "fa-dna": "\uf471",
    "fa-divide": "\uf529",
    "fa-ditto": "\u0022",
    "fa-distribute-spacing-vertical": "\ue366",
    "fa-distribute-spacing-horizontal": "\ue365",
    "fa-display-slash": "\ue2fa",
    "fa-display-medical": "\ue166",
    "fa-display-code": "\ue165",
    "fa-display-chart-up-circle-dollar": "\ue5e6",
    "fa-display-chart-up-circle-currency": "\ue5e5",
    "fa-display-chart-up": "\ue5e3",
    "fa-display-arrow-down": "\ue164",
    "fa-display": "\ue163",
    "fa-disease": "\uf7fa",
    "fa-disc-drive": "\uf8b5",
    "fa-diploma": "\uf5ea",
    "fa-dinosaur": "\ue5fe",
    "fa-dice-two": "\uf528",
    "fa-dice-three": "\uf527",
    "fa-dice-six": "\uf526",
    "fa-dice-one": "\uf525",
    "fa-dice-four": "\uf524",
    "fa-dice-five": "\uf523",
    "fa-dice-d8": "\uf6d2",
    "fa-dice-d6": "\uf6d1",
    "fa-dice-d4": "\uf6d0",
    "fa-dice-d20": "\uf6cf",
    "fa-dice-d12": "\uf6ce",
    "fa-dice-d10": "\uf6cd",
    "fa-diamond-turn-right": "\uf5eb",
    "fa-diamond-half-stroke": "\ue5b8",
    "fa-diamond-half": "\ue5b7",
    "fa-diamond-exclamation": "\ue405",
    "fa-dial-off": "\ue162",
    "fa-dial-min": "\ue161",
    "fa-dial-med-low": "\ue160",
    "fa-dial-med": "\ue15f",
    "fa-dial-max": "\ue15e",
    "fa-dial-low": "\ue15d",
    "fa-dial-high": "\ue15c",
    "fa-dial": "\ue15b",
    "fa-diagram-successor": "\ue47a",
    "fa-diagram-subtask": "\ue479",
    "fa-diagram-sankey": "\ue158",
    "fa-diagram-project": "\uf542",
    "fa-diagram-previous": "\ue478",
    "fa-diagram-predecessor": "\ue477",
    "fa-diagram-next": "\ue476",
    "fa-diagram-nested": "\ue157",
    "fa-diagram-lean-canvas": "\ue156",
    "fa-diagram-cells": "\ue475",
    "fa-dharmachakra": "\uf655",
    "fa-desktop-arrow-down": "\ue155",
    "fa-democrat": "\uf747",
    "fa-delete-right": "\ue154",
    "fa-delete-left": "\uf55a",
    "fa-deer-rudolph": "\uf78f",
    "fa-deer": "\uf78e",
    "fa-dash": "\ue404",
    "fa-dagger": "\uf6cb",
    "fa-d": "44",
    "fa-custard": "\ue403",
    "fa-curling-stone": "\uf44a",
    "fa-cupcake": "\ue402",
    "fa-cup-togo": "\uf6c5",
    "fa-cup-straw-swoosh": "\ue364",
    "fa-cup-straw": "\ue363",
    "fa-cucumber": "\ue401",
    "fa-cubes-stacked": "\ue4e6",
    "fa-cubes": "\uf1b3",
    "fa-crystal-ball": "\ue362",
    "fa-cruzeiro-sign": "\ue152",
    "fa-crutches": "\uf7f8",
    "fa-crutch": "\uf7f7",
    "fa-crow": "\uf520",
    "fa-crosshairs-simple": "\ue59f",
    "fa-crop-simple": "\uf565",
    "fa-crop": "\uf125",
    "fa-croissant": "\uf7f6",
    "fa-cricket-bat-ball": "\uf449",
    "fa-credit-card-front": "\uf38a",
    "fa-credit-card-blank": "\uf389",
    "fa-crate-empty": "\ue151",
    "fa-crate-apple": "\uf6b1",
    "fa-cowbell-circle-plus": "\uf8b4",
    "fa-cowbell": "\uf8b3",
    "fa-cow": "\uf6c8",
    "fa-court-sport": "\ue643",
    "fa-couch": "\uf4b8",
    "fa-corner": "\ue3fe",
    "fa-corn": "\uf6c7",
    "fa-cookie": "\uf563",
    "fa-conveyor-belt-empty": "\ue150",
    "fa-conveyor-belt-boxes": "\uf46f",
    "fa-conveyor-belt-arm": "\ue5f8",
    "fa-conveyor-belt": "\uf46e",
    "fa-computer-mouse": "\uf8cc",
    "fa-computer": "\ue4e5",
    "fa-compress-wide": "\uf326",
    "fa-compress": "\uf066",
    "fa-compass-slash": "\uf5e9",
    "fa-compass-drafting": "\uf568",
    "fa-compact-disc": "\uf51f",
    "fa-comments-question-check": "\ue14f",
    "fa-comments-question": "\ue14e",
    "fa-comment-xmark": "\uf4b5",
    "fa-comment-text": "\ue14d",
    "fa-comment-sms": "\uf7cd",
    "fa-comment-smile": "\uf4b4",
    "fa-comment-slash": "\uf4b3",
    "fa-comment-quote": "\ue14c",
    "fa-comment-question": "\ue14b",
    "fa-comment-plus": "\uf4b2",
    "fa-comment-pen": "\uf4ae",
    "fa-comment-music": "\uf8b0",
    "fa-comment-minus": "\uf4b1",
    "fa-comment-middle-top": "\ue14a",
    "fa-comment-middle": "\ue149",
    "fa-comment-medical": "\uf7f5",
    "fa-comment-lines": "\uf4b0",
    "fa-comment-image": "\ue148",
    "fa-comment-heart": "\ue5c8",
    "fa-comment-exclamation": "\uf4af",
    "fa-comment-dots": "\uf4ad",
    "fa-comment-dollar": "\uf651",
    "fa-comment-code": "\ue147",
    "fa-comment-check": "\uf4ac",
    "fa-comment-captions": "\ue146",
    "fa-comment-arrow-up-right": "\ue145",
    "fa-comment-arrow-up": "\ue144",
    "fa-comment-arrow-down": "\ue143",
    "fa-command": "\ue142",
    "fa-comma": "\u002c",
    "fa-comet": "\ue003",
    "fa-columns-3": "\ue361",
    "fa-colon-sign": "\ue140",
    "fa-colon": "3a",
    "fa-coin-vertical": "\ue3fd",
    "fa-coin-front": "\ue3fc",
    "fa-coin-blank": "\ue3fb",
    "fa-coffin-cross": "\ue051",
    "fa-coffin": "\uf6c6",
    "fa-coffee-pot": "\ue002",
    "fa-coffee-beans": "\ue13f",
    "fa-coffee-bean": "\ue13e",
    "fa-code-simple": "\ue13d",
    "fa-code-pull-request-draft": "\ue3fa",
    "fa-code-pull-request-closed": "\ue3f9",
    "fa-code-pull-request": "\ue13c",
    "fa-circle-z": "\ue130",
    "fa-circle-yen": "\ue5d0",
    "fa-circle-y": "\ue12f",
    "fa-circle-x": "\ue12e",
    "fa-circle-wifi-circle-wifi": "\ue67e",
    "fa-circle-wifi": "\ue67d",
    "fa-circle-waveform-lines": "\ue12d",
    "fa-code-merge": "\uf387",
    "fa-code-fork": "\ue13b",
    "fa-code-commit": "\uf386",
    "fa-coconut": "\ue2f6",
    "fa-club": "\uf327",
    "fa-clover": "\ue139",
    "fa-clouds-sun": "\uf746",
    "fa-clouds-moon": "\uf745",
    "fa-clouds": "\uf744",
    "fa-cloud-xmark": "\ue35f",
    "fa-cloud-word": "\ue138",
    "fa-cloud-sun-rain": "\uf743",
    "fa-cloud-sun": "\uf6c4",
    "fa-cloud-snow": "\uf742",
    "fa-cloud-sleet": "\uf741",
    "fa-cloud-slash": "\ue137",
    "fa-cloud-showers-water": "\ue4e4",
    "fa-cloud-showers-heavy": "\uf740",
    "fa-cloud-showers": "\uf73f",
    "fa-cloud-rainbow": "\uf73e",
    "fa-cloud-rain": "\uf73d",
    "fa-cloud-question": "\ue492",
    "fa-cloud-plus": "\ue35e",
    "fa-cloud-music": "\uf8ae",
    "fa-cloud-moon-rain": "\uf73c",
    "fa-cloud-moon": "\uf6c3",
    "fa-cloud-minus": "\ue35d",
    "fa-cloud-meatball": "\uf73b",
    "fa-cloud-hail-mixed": "\uf73a",
    "fa-cloud-hail": "\uf739",
    "fa-cloud-fog": "\uf74e",
    "fa-cloud-exclamation": "\ue491",
    "fa-cloud-drizzle": "\uf738",
    "fa-cloud-check": "\ue35c",
    "fa-cloud-bolt-sun": "\uf76e",
    "fa-cloud-bolt-moon": "\uf76d",
    "fa-cloud-bolt": "\uf76c",
    "fa-cloud-binary": "\ue601",
    "fa-cloud-arrow-down": "\uf0ed",
    "fa-clothes-hanger": "\ue136",
    "fa-closed-captioning-slash": "\ue135",
    "fa-clock-two-thirty": "\ue35b",
    "fa-clock-two": "\ue35a",
    "fa-clock-twelve-thirty": "\ue359",
    "fa-clock-twelve": "\ue358",
    "fa-clock-three-thirty": "\ue357",
    "fa-clock-three": "\ue356",
    "fa-clock-ten-thirty": "\ue355",
    "fa-clock-ten": "\ue354",
    "fa-clock-six-thirty": "\ue353",
    "fa-clock-six": "\ue352",
    "fa-clock-seven-thirty": "\ue351",
    "fa-clock-seven": "\ue350",
    "fa-clock-rotate-left": "\uf1da",
    "fa-clock-one-thirty": "\ue34f",
    "fa-clock-one": "\ue34e",
    "fa-clock-nine-thirty": "\ue34d",
    "fa-clock-nine": "\ue34c",
    "fa-clock-four-thirty": "\ue34b",
    "fa-clock-five-thirty": "\ue34a",
    "fa-clock-five": "\ue349",
    "fa-clock-eleven-thirty": "\ue348",
    "fa-clock-eleven": "\ue347",
    "fa-clock-eight-thirty": "\ue346",
    "fa-clock-eight": "\ue345",
    "fa-clock-desk": "\ue134",
    "fa-clipboard-user": "\uf7f3",
    "fa-clipboard-question": "\ue4e3",
    "fa-clipboard-prescription": "\uf5e8",
    "fa-clipboard-medical": "\ue133",
    "fa-clipboard-list-check": "\uf737",
    "fa-clipboard-list": "\uf46d",
    "fa-clipboard-check": "\uf46c",
    "fa-claw-marks": "\uf6c2",
    "fa-clarinet": "\uf8ad",
    "fa-clapperboard-play": "\ue132",
    "fa-clapperboard": "\ue131",
    "fa-citrus-slice": "\ue2f5",
    "fa-citrus": "\ue2f4",
    "fa-circles-overlap": "\ue600",
    "fa-circle-w": "\ue12c",
    "fa-circle-video": "\ue12b",
    "fa-circle-v": "\ue12a",
    "fa-circle-up-right": "\ue129",
    "fa-circle-up-left": "\ue128",
    "fa-circle-u": "\ue127",
    "fa-circle-trash": "\ue126",
    "fa-circle-three-quarters-stroke": "\ue5d4",
    "fa-circle-three-quarters": "\ue125",
    "fa-circle-t": "\ue124",
    "fa-circle-stop": "\uf28d",
    "fa-circle-sterling": "\ue5cf",
    "fa-circle-star": "\ue123",
    "fa-circle-sort-up": "\ue032",
    "fa-circle-sort-down": "\ue031",
    "fa-circle-sort": "\ue030",
    "fa-circle-small": "\ue122",
    "fa-circle-s": "\ue121",
    "fa-circle-right": "\uf35a",
    "fa-circle-radiation": "\uf7ba",
    "fa-circle-r": "\ue120",
    "fa-circle-question": "\uf059",
    "fa-circle-quarters": "\ue3f8",
    "fa-circle-quarter-stroke": "\ue5d3",
    "fa-circle-quarter": "\ue11f",
    "fa-circle-q": "\ue11e",
    "fa-circle-plus": "\uf055",
    "fa-circle-play": "\uf144",
    "fa-circle-phone-hangup": "\ue11d",
    "fa-circle-phone-flip": "\ue11c",
    "fa-circle-phone": "\ue11b",
    "fa-circle-pause": "\uf28b",
    "fa-circle-parking": "\uf615",
    "fa-circle-p": "\ue11a",
    "fa-circle-o": "\ue119",
    "fa-circle-nodes": "\ue4e2",
    "fa-circle-n": "\ue118",
    "fa-circle-minus": "\uf056",
    "fa-circle-microphone-lines": "\ue117",
    "fa-circle-microphone": "\ue116",
    "fa-circle-m": "\ue115",
    "fa-circle-location-arrow": "\uf602",
    "fa-circle-left": "\uf359",
    "fa-circle-l": "\ue114",
    "fa-circle-k": "\ue113",
    "fa-circle-j": "\ue112",
    "fa-circle-i": "\ue111",
    "fa-circle-heart": "\uf4c7",
    "fa-circle-half": "\ue110",
    "fa-circle-h": "\uf47e",
    "fa-circle-gf": "\ue67f",
    "fa-circle-g": "\ue10f",
    "fa-circle-f": "\ue10e",
    "fa-circle-exclamation-check": "\ue10d",
    "fa-circle-euro": "\ue5ce",
    "fa-circle-envelope": "\ue10c",
    "fa-circle-ellipsis-vertical": "\ue10b",
    "fa-circle-ellipsis": "\ue10a",
    "fa-circle-e": "\ue109",
    "fa-circle-down-right": "\ue108",
    "fa-circle-down-left": "\ue107",
    "fa-circle-dot": "\uf192",
    "fa-circle-dollar-to-slot": "\uf4b9",
    "fa-circle-dollar": "\uf2e8",
    "fa-circle-divide": "\ue106",
    "fa-circle-dashed": "\ue105",
    "fa-circle-d": "\ue104",
    "fa-circle-chevron-up": "\uf139",
    "fa-circle-chevron-right": "\uf138",
    "fa-circle-chevron-left": "\uf137",
    "fa-circle-chevron-down": "\uf13a",
    "fa-circle-caret-up": "\uf331",
    "fa-circle-caret-right": "\uf330",
    "fa-circle-caret-left": "\uf32e",
    "fa-circle-caret-down": "\uf32d",
    "fa-circle-camera": "\ue103",
    "fa-circle-calendar": "\ue102",
    "fa-circle-c": "\ue101",
    "fa-circle-bookmark": "\ue100",
    "fa-circle-book-open": "\ue0ff",
    "fa-circle-bolt": "\ue0fe",
    "fa-circle-b": "\ue0fd",
    "fa-circle-arrow-up-right": "\ue0fc",
    "fa-circle-arrow-up-left": "\ue0fb",
    "fa-circle-arrow-up": "\uf0aa",
    "fa-circle-arrow-right": "\uf0a9",
    "fa-circle-arrow-left": "\uf0a8",
    "fa-circle-arrow-down-right": "\ue0fa",
    "fa-circle-arrow-down-left": "\ue0f9",
    "fa-circle-arrow-down": "\uf0ab",
    "fa-circle-ampersand": "\ue0f8",
    "fa-circle-a": "\ue0f7",
    "fa-circle-9": "\ue0f6",
    "fa-circle-8": "\ue0f5",
    "fa-circle-7": "\ue0f4",
    "fa-circle-6": "\ue0f3",
    "fa-circle-5": "\ue0f2",
    "fa-circle-4": "\ue0f1",
    "fa-circle-3": "\ue0f0",
    "fa-circle-2": "\ue0ef",
    "fa-circle-1": "\ue0ee",
    "fa-circle-0": "\ue0ed",
    "fa-chopsticks": "\ue3f7",
    "fa-chimney": "\uf78b",
    "fa-children": "\ue4e1",
    "fa-child-reaching": "\ue59d",
    "fa-child-dress": "\ue59c",
    "fa-child-combatant": "\ue4e0",
    "fa-chf-sign": "\ue602",
    "fa-chevrons-up": "\uf325",
    "fa-chevrons-right": "\uf324",
    "fa-chevrons-left": "\uf323",
    "fa-chevrons-down": "\uf322",
    "fa-chevron-right": "\uf054",
    "fa-chevron-left": "\uf053",
    "fa-chestnut": "\ue3f6",
    "fa-chess-rook-piece": "\uf448",
    "fa-chess-rook": "\uf447",
    "fa-chess-queen-piece": "\uf446",
    "fa-chess-queen": "\uf445",
    "fa-chess-pawn-piece": "\uf444",
    "fa-chess-pawn": "\uf443",
    "fa-chess-knight-piece": "\uf442",
    "fa-chess-knight": "\uf441",
    "fa-chess-king-piece": "\uf440",
    "fa-chess-king": "\uf43f",
    "fa-chess-clock-flip": "\uf43e",
    "fa-chess-clock": "\uf43d",
    "fa-chess-board": "\uf43c",
    "fa-chess-bishop-piece": "\uf43b",
    "fa-chess-bishop": "\uf43a",
    "fa-chess": "\uf439",
    "fa-cherries": "\ue0ec",
    "fa-cheese-swiss": "\uf7f0",
    "fa-cheese": "\uf7ef",
    "fa-check-to-slot": "\uf772",
    "fa-check-double": "\uf560",
    "fa-chart-waterfall": "\ue0eb",
    "fa-chart-user": "\uf6a3",
    "fa-chart-tree-map": "\ue0ea",
    "fa-chart-simple-horizontal": "\ue474",
    "fa-chart-scatter-bubble": "\ue0e9",
    "fa-chart-scatter-3d": "\ue0e8",
    "fa-chart-radar": "\ue0e7",
    "fa-chart-pyramid": "\ue0e6",
    "fa-chart-pie-simple-circle-dollar": "\ue605",
    "fa-chart-pie-simple-circle-currency": "\ue604",
    "fa-chart-pie-simple": "\uf64e",
    "fa-chart-pie": "\uf200",
    "fa-chart-network": "\uf78a",
    "fa-chart-mixed-up-circle-dollar": "\ue5d9",
    "fa-chart-mixed-up-circle-currency": "\ue5d8",
    "fa-chart-mixed": "\uf643",
    "fa-chart-line-up-down": "\ue5d7",
    "fa-chart-line-up": "\ue0e5",
    "fa-chart-line-down": "\uf64d",
    "fa-chart-line": "\uf201",
    "fa-chart-kanban": "\ue64f",
    "fa-chart-gantt": "\ue0e4",
    "fa-chart-column": "\ue0e3",
    "fa-chart-candlestick": "\ue0e2",
    "fa-chart-bullet": "\ue0e1",
    "fa-chart-bar": "\uf080",
    "fa-chart-area": "\uf1fe",
    "fa-charging-station": "\uf5e7",
    "fa-champagne-glasses": "\uf79f",
    "fa-champagne-glass": "\uf79e",
    "fa-chalkboard-user": "\uf51c",
    "fa-chair-office": "\uf6c1",
    "fa-cent-sign": "\ue3f5",
    "fa-cedi-sign": "\ue0df",
    "fa-cat-space": "\ue001",
    "fa-cat": "\uf6be",
    "fa-castle": "\ue0de",
    "fa-cassette-vhs": "\uf8ec",
    "fa-cassette-tape": "\uf8ab",
    "fa-cassette-betamax": "\uf8a4",
    "fa-cart-xmark": "\ue0dd",
    "fa-cart-shopping-fast": "\ue0dc",
    "fa-cart-minus": "\ue0db",
    "fa-cart-flatbed-suitcase": "\uf59d",
    "fa-cart-flatbed-empty": "\uf476",
    "fa-cart-flatbed-boxes": "\uf475",
    "fa-cart-flatbed": "\uf474",
    "fa-cart-circle-xmark": "\ue3f4",
    "fa-cart-circle-plus": "\ue3f3",
    "fa-cart-circle-exclamation": "\ue3f2",
    "fa-cart-circle-check": "\ue3f1",
    "fa-cart-circle-arrow-up": "\ue3f0",
    "fa-cart-circle-arrow-down": "\ue3ef",
    "fa-cart-arrow-up": "\ue3ee",
    "fa-cart-arrow-down": "\uf218",
    "fa-cars": "\uf85b",
    "fa-carrot": "\uf787",
    "fa-caret-right": "\uf0da",
    "fa-caret-left": "\uf0d9",
    "fa-cards-blank": "\ue4df",
    "fa-cards": "\ue3ed",
    "fa-card-spade": "\ue3ec",
    "fa-card-heart": "\ue3eb",
    "fa-card-diamond": "\ue3ea",
    "fa-card-club": "\ue3e9",
    "fa-caravan-simple": "\ue000",
    "fa-caravan": "\uf8ff",
    "fa-car-wrench": "\uf5e3",
    "fa-car-wash": "\uf5e6",
    "fa-car-tunnel": "\ue4de",
    "fa-car-tilt": "\uf5e5",
    "fa-car-side-bolt": "\ue344",
    "fa-car-rear": "\uf5de",
    "fa-car-on": "\ue4dd",
    "fa-car-mirrors": "\ue343",
    "fa-car-garage": "\uf5e2",
    "fa-car-circle-bolt": "\ue342",
    "fa-car-bus": "\uf85a",
    "fa-car-burst": "\uf5e1",
    "fa-car-bump": "\uf5e0",
    "fa-car-bolt": "\ue341",
    "fa-car-battery": "\uf5df",
    "fa-capsules": "\uf46b",
    "fa-cannon": "\ue642",
    "fa-cannabis": "\uf55f",
    "fa-candy-corn": "\uf6bd",
    "fa-candy-cane": "\uf786",
    "fa-candy-bar": "\ue3e8",
    "fa-candy": "\ue3e7",
    "fa-candle-holder": "\uf6bc",
    "fa-can-food": "\ue3e6",
    "fa-campground": "\uf6bb",
    "fa-camera-web-slash": "\uf833",
    "fa-camera-web": "\uf832",
    "fa-camera-viewfinder": "\ue0da",
    "fa-camera-slash": "\ue0d9",
    "fa-camera-security": "\uf8fe",
    "fa-camera-rotate": "\ue0d8",
    "fa-camera-polaroid": "\uf8aa",
    "fa-camera-cctv": "\uf8ac",
    "fa-camcorder": "\uf8a8",
    "fa-calendars": "\ue0d7",
    "fa-calendar-xmark": "\uf273",
    "fa-calendar-users": "\ue5e2",
    "fa-calendar-star": "\uf736",
    "fa-calendar-range": "\ue0d6",
    "fa-calendar-plus": "\uf271",
    "fa-calendar-pen": "\uf333",
    "fa-calendar-minus": "\uf272",
    "fa-calendar-lines-pen": "\ue472",
    "fa-calendar-lines": "\ue0d5",
    "fa-calendar-image": "\ue0d4",
    "fa-calendar-heart": "\ue0d3",
    "fa-calendar-exclamation": "\uf334",
    "fa-calendar-day": "\uf783",
    "fa-calendar-clock": "\ue0d2",
    "fa-calendar-circle-user": "\ue471",
    "fa-calendar-circle-plus": "\ue470",
    "fa-calendar-circle-minus": "\ue46f",
    "fa-calendar-circle-exclamation": "\ue46e",
    "fa-calendar-check": "\uf274",
    "fa-calendar-arrow-up": "\ue0d1",
    "fa-calendar-arrow-down": "\ue0d0",
    "fa-calculator-simple": "\uf64c",
    "fa-cake-slice": "\ue3e5",
    "fa-cake-candles": "\uf1fd",
    "fa-caduceus": "\ue681",
    "fa-cactus": "\uf8a7",
    "fa-cabinet-filing": "\uf64b",
    "fa-cabin": "\ue46d",
    "fa-c": "43",
    "fa-butter": "\ue3e4",
    "fa-bus-simple": "\uf55e",
    "fa-bus-school": "\uf5dd",
    "fa-bus": "\uf207",
    "fa-burst": "\ue4dc",
    "fa-burger-lettuce": "\ue3e3",
    "fa-burger-glass": "\ue0ce",
    "fa-burger-fries": "\ue0cd",
    "fa-burger-cheese": "\uf7f1",
    "fa-burger": "\uf805",
    "fa-buoy-mooring": "\ue5b6",
    "fa-buoy": "\ue5b5",
    "fa-bullseye-arrow": "\uf648",
    "fa-bullhorn": "\uf0a1",
    "fa-bulldozer": "\ue655",
    "fa-buildings": "\ue0cc",
    "fa-building-wheat": "\ue4db",
    "fa-building-user": "\ue4da",
    "fa-building-un": "\ue4d9",
    "fa-building-shield": "\ue4d8",
    "fa-building-ngo": "\ue4d7",
    "fa-building-memo": "\ue61e",
    "fa-building-magnifying-glass": "\ue61c",
    "fa-building-lock": "\ue4d6",
    "fa-building-flag": "\ue4d5",
    "fa-building-columns": "\uf19c",
    "fa-building-circle-xmark": "\ue4d4",
    "fa-building-circle-exclamation": "\ue4d3",
    "fa-building-circle-check": "\ue4d2",
    "fa-building-circle-arrow-right": "\ue4d1",
    "fa-bugs": "\ue4d0",
    "fa-bug-slash": "\ue490",
    "fa-bucket": "\ue4cf",
    "fa-browsers": "\ue0cb",
    "fa-broom-wide": "\ue5d1",
    "fa-broom-ball": "\uf458",
    "fa-broom": "\uf51a",
    "fa-broccoli": "\ue3e2",
    "fa-bring-front": "\uf857",
    "fa-bring-forward": "\uf856",
    "fa-brightness-low": "\ue0ca",
    "fa-brightness": "\ue0c9",
    "fa-briefcase-medical": "\uf469",
    "fa-briefcase-blank": "\ue0c8",
    "fa-briefcase-arrow-right": "\ue2f2",
    "fa-bridge-water": "\ue4ce",
    "fa-bridge-suspension": "\ue4cd",
    "fa-bridge-lock": "\ue4cc",
    "fa-bridge-circle-xmark": "\ue4cb",
    "fa-bridge-circle-exclamation": "\ue4ca",
    "fa-bridge-circle-check": "\ue4c9",
    "fa-bridge": "\ue4c8",
    "fa-bread-slice-butter": "\ue3e1",
    "fa-bread-slice": "\uf7ec",
    "fa-bread-loaf": "\uf7eb",
    "fa-brazilian-real-sign": "\ue46c",
    "fa-brake-warning": "\ue0c7",
    "fa-brain-circuit": "\ue0c6",
    "fa-brain-arrow-curved-right": "\uf677",
    "fa-braille": "\uf2a1",
    "fa-brackets-square": "\uf7e9",
    "fa-brackets-round": "\ue0c5",
    "fa-bracket-square-right": "5d",
    "fa-bracket-square": "5b",
    "fa-bracket-round-right": "\u0029",
    "fa-bracket-round": "\u0028",
    "fa-bracket-curly-right": "7d",
    "fa-bracket-curly": "7b",
    "fa-boxing-glove": "\uf438",
    "fa-boxes-stacked": "\uf468",
    "fa-boxes-packing": "\ue4c7",
    "fa-box-tissue": "\ue05b",
    "fa-box-taped": "\uf49a",
    "fa-box-open-full": "\uf49c",
    "fa-box-open": "\uf49e",
    "fa-box-heart": "\uf49d",
    "fa-box-dollar": "\uf4a0",
    "fa-box-circle-check": "\ue0c4",
    "fa-box-check": "\uf467",
    "fa-box-ballot": "\uf735",
    "fa-box-archive": "\uf187",
    "fa-box": "\uf466",
    "fa-bowling-pins": "\uf437",
    "fa-bowling-ball-pin": "\ue0c3",
    "fa-bowling-ball": "\uf436",
    "fa-bowl-spoon": "\ue3e0",
    "fa-bowl-soft-serve": "\ue46b",
    "fa-bowl-scoops": "\ue3df",
    "fa-bowl-scoop": "\ue3de",
    "fa-bowl-rice": "\ue2eb",
    "fa-bowl-hot": "\uf823",
    "fa-bowl-food": "\ue4c6",
    "fa-bowl-chopsticks": "\ue2e9",
    "fa-bow-arrow": "\uf6b9",
    "fa-bottle-water": "\ue4c5",
    "fa-bottle-droplet": "\ue4c4",
    "fa-bottle-baby": "\ue673",
    "fa-bore-hole": "\ue4c3",
    "fa-border-top-left": "\uf853",
    "fa-border-right": "\uf852",
    "fa-border-outer": "\uf851",
    "fa-border-left": "\uf84f",
    "fa-border-inner": "\uf84e",
    "fa-border-center-v": "\uf89d",
    "fa-border-center-h": "\uf89c",
    "fa-border-bottom-right": "\uf854",
    "fa-border-bottom": "\uf84d",
    "fa-border-all": "\uf84c",
    "fa-boot-heeled": "\ue33f",
    "fa-boot": "\uf782",
    "fa-boombox": "\uf8a5",
    "fa-books-medical": "\uf7e8",
    "fa-bookmark-slash": "\ue0c2",
    "fa-book-user": "\uf7e7",
    "fa-book-tanakh": "\uf827",
    "fa-book-sparkles": "\uf6b8",
    "fa-book-skull": "\uf6b7",
    "fa-book-section": "\ue0c1",
    "fa-book-quran": "\uf687",
    "fa-book-open-reader": "\uf5da",
    "fa-book-open-cover": "\ue0c0",
    "fa-book-open": "\uf518",
    "fa-book-medical": "\uf7e6",
    "fa-book-journal-whills": "\uf66a",
    "fa-book-heart": "\uf499",
    "fa-book-font": "\ue0bf",
    "fa-book-copy": "\ue0be",
    "fa-book-circle-arrow-up": "\ue0bd",
    "fa-book-circle-arrow-right": "\ue0bc",
    "fa-book-bookmark": "\ue0bb",
    "fa-book-blank": "\uf5d9",
    "fa-book-bible": "\uf647",
    "fa-book-atlas": "\uf558",
    "fa-book-arrow-up": "\ue0ba",
    "fa-book-arrow-right": "\ue0b9",
    "fa-bong": "\uf55c",
    "fa-bone-break": "\uf5d8",
    "fa-bone": "\uf5d7",
    "fa-bolt-slash": "\ue0b8",
    "fa-bolt-lightning": "\ue0b7",
    "fa-bolt-auto": "\ue0b6",
    "fa-bold": "\uf032",
    "fa-bluetooth": "\uf293",
    "fa-blueberries": "\ue2e8",
    "fa-block-quote": "\ue0b5",
    "fa-block-brick-fire": "\ue3dc",
    "fa-block-brick": "\ue3db",
    "fa-block": "\ue46a",
    "fa-blinds-open": "\uf8fc",
    "fa-blinds": "\uf8fb",
    "fa-blender-phone": "\uf6b6",
    "fa-blender": "\uf517",
    "fa-blanket-fire": "\ue3da",
    "fa-bitcoin-sign": "\ue0b4",
    "fa-biohazard": "\uf780",
    "fa-binary-slash": "\ue33e",
    "fa-binary-lock": "\ue33d",
    "fa-binary-circle-check": "\ue33c",
    "fa-binary": "\ue33b",
    "fa-bin-recycle": "\ue5f7",
    "fa-bin-bottles-recycle": "\ue5f6",
    "fa-bin-bottles": "\ue5f5",
    "fa-billboard": "\ue5cd",
    "fa-bezier-curve": "\uf55b",
    "fa-bench-tree": "\ue2e7",
    "fa-bells": "\uf77f",
    "fa-bell-slash": "\uf1f6",
    "fa-bell-school-slash": "\uf5d6",
    "fa-bell-school": "\uf5d5",
    "fa-bell-ring": "\ue62c",
    "fa-bell-plus": "\uf849",
    "fa-bell-on": "\uf8fa",
    "fa-bell-exclamation": "\uf848",
    "fa-bell-concierge": "\uf562",
    "fa-beer-mug-empty": "\uf0fc",
    "fa-beer-mug": "\ue0b3",
    "fa-bee": "\ue0b2",
    "fa-bed-pulse": "\uf487",
    "fa-bed-empty": "\uf8f9",
    "fa-bed-bunk": "\uf8f8",
    "fa-bed": "\uf236",
    "fa-battery-three-quarters": "\uf241",
    "fa-battery-slash": "\uf377",
    "fa-battery-quarter": "\uf243",
    "fa-battery-low": "\ue0b1",
    "fa-battery-half": "\uf242",
    "fa-battery-full": "\uf240",
    "fa-battery-exclamation": "\ue0b0",
    "fa-battery-empty": "\uf244",
    "fa-battery-bolt": "\uf376",
    "fa-basketball": "\uf434",
    "fa-basket-shopping-simple": "\ue0af",
    "fa-basket-shopping-plus": "\ue653",
    "fa-basket-shopping-minus": "\ue652",
    "fa-basket-shopping": "\uf291",
    "fa-baseball-bat-ball": "\uf432",
    "fa-baseball": "\uf433",
    "fa-bars-staggered": "\uf550",
    "fa-bars-sort": "\ue0ae",
    "fa-bars-progress": "\uf828",
    "fa-bars-filter": "\ue0ad",
    "fa-barcode-scan": "\uf465",
    "fa-barcode-read": "\uf464",
    "fa-banjo": "\uf8a3",
    "fa-bangladeshi-taka-sign": "\ue2e6",
    "fa-bandage": "\uf462",
    "fa-banana": "\ue2e5",
    "fa-ban-smoking": "\uf54d",
    "fa-ban-parking": "\uf616",
    "fa-ban-bug": "\uf7f9",
    "fa-ban": "\uf05e",
    "fa-ballot": "\uf732",
    "fa-balloon": "\ue2e3",
    "fa-ball-pile": "\uf77e",
    "fa-baht-sign": "\ue0ac",
    "fa-bahai": "\uf666",
    "fa-baguette": "\ue3d8",
    "fa-bags-shopping": "\uf847",
    "fa-bagel": "\ue3d7",
    "fa-bag-shopping-plus": "\ue651",
    "fa-bag-shopping-minus": "\ue650",
    "fa-bag-seedling": "\ue5f2",
    "fa-badminton": "\ue33a",
    "fa-badger-honey": "\uf6b4",
    "fa-badge-sheriff": "\uf8a2",
    "fa-badge-percent": "\uf646",
    "fa-badge-dollar": "\uf645",
    "fa-bacterium": "\ue05a",
    "fa-bacteria": "\ue059",
    "fa-bacon": "\uf7e5",
    "fa-backward-step": "\uf048",
    "fa-backward-fast": "\uf049",
    "fa-backpack": "\uf5d4",
    "fa-baby-carriage": "\uf77d",
    "fa-b": "42",
    "fa-axe-battle": "\uf6b3",
    "fa-axe": "\uf6b2",
    "fa-award-simple": "\ue0ab",
    "fa-avocado": "\ue0aa",
    "fa-austral-sign": "\ue0a9",
    "fa-audio-description-slash": "\ue0a8",
    "fa-atom": "\uf5d2",
    "fa-at": "40",
    "fa-asterisk": "\u002a",
    "fa-arrows-up-to-line": "\ue4c2",
    "fa-arrows-up-down-left-right": "\uf047",
    "fa-arrows-up-down": "\uf07d",
    "fa-arrows-turn-to-dots": "\ue4c1",
    "fa-arrows-turn-right": "\ue4c0",
    "fa-arrows-to-line": "\ue0a7",
    "fa-arrows-to-eye": "\ue4bf",
    "fa-arrows-to-dotted-line": "\ue0a6",
    "fa-arrows-to-dot": "\ue4be",
    "fa-arrows-to-circle": "\ue4bd",
    "fa-arrows-split-up-and-left": "\ue4bc",
    "fa-arrows-spin": "\ue4bb",
    "fa-arrows-rotate-reverse": "\ue630",
    "fa-arrows-rotate": "\uf021",
    "fa-arrows-retweet": "\uf361",
    "fa-arrows-repeat-1": "\uf366",
    "fa-arrows-repeat": "\uf364",
    "fa-arrows-minimize": "\ue0a5",
    "fa-arrows-maximize": "\uf31d",
    "fa-arrows-left-right-to-line": "\ue4ba",
    "fa-arrows-left-right": "\uf07e",
    "fa-arrows-from-line": "\ue0a4",
    "fa-arrows-from-dotted-line": "\ue0a3",
    "fa-arrows-down-to-people": "\ue4b9",
    "fa-arrows-down-to-line": "\ue4b8",
    "fa-arrows-cross": "\ue0a2",
    "fa-arrow-up-z-a": "\uf882",
    "fa-arrow-up-wide-short": "\uf161",
    "fa-arrow-up-triangle-square": "\uf88a",
    "fa-arrow-up-to-line": "\uf341",
    "fa-arrow-up-to-dotted-line": "\ue0a1",
    "fa-arrow-up-to-bracket": "\ue66a",
    "fa-arrow-up-to-arc": "\ue617",
    "fa-arrow-up-square-triangle": "\uf88b",
    "fa-arrow-up-small-big": "\uf88f",
    "fa-arrow-up-short-wide": "\uf885",
    "fa-arrow-up-right-dots": "\ue4b7",
    "fa-arrow-up-right-and-arrow-down-left-from-center": "\ue0a0",
    "fa-arrow-up-right": "\ue09f",
    "fa-arrow-up-long": "\uf176",
    "fa-arrow-up-left-from-circle": "\ue09e",
    "fa-arrow-up-left": "\ue09d",
    "fa-arrow-up-from-water-pump": "\ue4b6",
    "fa-arrow-up-from-square": "\ue09c",
    "fa-arrow-up-from-line": "\uf342",
    "fa-arrow-up-from-ground-water": "\ue4b5",
    "fa-arrow-up-from-dotted-line": "\ue09b",
    "fa-arrow-up-from-arc": "\ue4b4",
    "fa-arrow-up-big-small": "\uf88e",
    "fa-arrow-up-arrow-down": "\ue099",
    "fa-arrow-up-a-z": "\uf15e",
    "fa-arrow-up-9-1": "\uf887",
    "fa-arrow-up-1-9": "\uf163",
    "fa-arrow-turn-up": "\uf148",
    "fa-arrow-turn-right": "\ue635",
    "fa-arrow-turn-left-up": "\ue634",
    "fa-arrow-turn-left-down": "\ue633",
    "fa-arrow-turn-left": "\ue632",
    "fa-arrow-turn-down-right": "\ue3d6",
    "fa-arrow-turn-down-left": "\ue2e1",
    "fa-arrow-turn-down": "\uf149",
    "fa-arrow-trend-up": "\ue098",
    "fa-arrow-trend-down": "\ue097",
    "fa-arrow-rotate-right": "\uf01e",
    "fa-arrow-rotate-left": "\uf0e2",
    "fa-arrow-right-to-line": "\uf340",
    "fa-arrow-right-to-city": "\ue4b3",
    "fa-arrow-right-to-bracket": "\uf090",
    "fa-arrow-right-to-arc": "\ue4b2",
    "fa-arrow-right-long-to-line": "\ue3d5",
    "fa-arrow-right-long": "\uf178",
    "fa-arrow-right-from-line": "\uf343",
    "fa-arrow-right-from-bracket": "\uf08b",
    "fa-arrow-right-from-arc": "\ue4b1",
    "fa-arrow-right-arrow-left": "\uf0ec",
    "fa-arrow-progress": "\ue5df",
    "fa-arrow-pointer": "\uf245",
    "fa-arrow-left-to-line": "\uf33e",
    "fa-arrow-left-to-bracket": "\ue669",
    "fa-arrow-left-to-arc": "\ue616",
    "fa-arrow-left-long-to-line": "\ue3d4",
    "fa-arrow-left-long": "\uf177",
    "fa-arrow-left-from-line": "\uf344",
    "fa-arrow-left-from-bracket": "\ue668",
    "fa-arrow-left-from-arc": "\ue615",
    "fa-arrow-down-z-a": "\uf881",
    "fa-arrow-down-wide-short": "\uf160",
    "fa-arrow-down-up-lock": "\ue4b0",
    "fa-arrow-down-up-across-line": "\ue4af",
    "fa-arrow-down-triangle-square": "\uf888",
    "fa-arrow-down-to-square": "\ue096",
    "fa-arrow-down-to-dotted-line": "\ue095",
    "fa-arrow-down-to-bracket": "\ue094",
    "fa-arrow-down-to-arc": "\ue4ae",
    "fa-arrow-down-square-triangle": "\uf889",
    "fa-arrow-down-small-big": "\uf88d",
    "fa-arrow-down-short-wide": "\uf884",
    "fa-arrow-down-right": "\ue093",
    "fa-arrow-down-long": "\uf175",
    "fa-arrow-down-left-and-arrow-up-right-to-center": "\ue092",
    "fa-arrow-down-left": "\ue091",
    "fa-arrow-down-from-line": "\uf345",
    "fa-arrow-down-from-dotted-line": "\ue090",
    "fa-arrow-down-from-bracket": "\ue667",
    "fa-arrow-down-from-arc": "\ue614",
    "fa-arrow-down-big-small": "\uf88c",
    "fa-arrow-down-arrow-up": "\uf883",
    "fa-arrow-down-a-z": "\uf15d",
    "fa-arrow-down-9-1": "\uf886",
    "fa-arrow-down-1-9": "\uf162",
    "fa-archway": "\uf557",
    "fa-apple-whole": "\uf5d1",
    "fa-apple-core": "\ue08f",
    "fa-apostrophe": "\u0027",
    "fa-apartment": "\ue468",
    "fa-ant": "\ue680",
    "fa-ankh": "\uf644",
    "fa-angles-up-down": "\ue60d",
    "fa-angles-up": "\uf101",
    "fa-angles-left": "\uf100",
    "fa-angles-down": "\uf103",
    "fa-angle-right": "\uf105",
    "fa-angle-left": "\uf104",
    "fa-angle-down": "\uf107",
    "fa-angle-90": "\ue08d",
    "fa-angle": "\ue08c",
    "fa-angel": "\uf779",
    "fa-anchor-lock": "\ue4ad",
    "fa-anchor-circle-xmark": "\ue4ac",
    "fa-anchor-circle-exclamation": "\ue4ab",
    "fa-anchor-circle-check": "\ue4aa",
    "fa-ampersand": "\u0026",
    "fa-amp-guitar": "\uf8a1",
    "fa-alt": "\ue08a",
    "fa-align-right": "\uf038",
    "fa-align-left": "\uf036",
    "fa-align-justify": "\uf039",
    "fa-align-center": "\uf037",
    "fa-alien": "\uf8f5",
    "fa-alicorn": "\uf6b0",
    "fa-album-collection-circle-user": "\ue48f",
    "fa-album-collection-circle-plus": "\ue48e",
    "fa-album-collection": "\uf8a0",
    "fa-album-circle-user": "\ue48d",
    "fa-album-circle-plus": "\ue48c",
    "fa-alarm-plus": "\uf844",
    "fa-alarm-exclamation": "\uf843",
    "fa-airplay": "\ue089",
    "fa-air-conditioner": "\uf8f4",
    "fa-acorn": "\uf6ae",
    "fa-accent-grave": "60",
    "fa-abacus": "\uf640",
    "fa-a": "41",
    "fa-9": "39",
    "fa-8": "38",
    "fa-7": "37",
    "fa-6": "36",
    "fa-5": "35",
    "fa-4": "34",
    "fa-360-degrees": "\ue2dc",
    "fa-3": "33",
    "fa-2": "32",
    "fa-1": "31",
    "fa-00": "\ue467",
    "fa-0": "30",
    "fa-zhihu": "\uf63f",
    "fa-yoast": "\uf2b1",
    "fa-yelp": "\uf1e9",
    "fa-yarn": "\uf7e3",
    "fa-yandex-international": "\uf414",
    "fa-yandex": "\uf413",
    "fa-yammer": "\uf840",
    "fa-yahoo": "\uf19e",
    "fa-y-combinator": "\uf23b",
    "fa-xing": "\uf168",
    "fa-xbox": "\uf412",
    "fa-x-twitter": "\ue61b",
    "fa-wpressr": "\uf3e4",
    "fa-wpforms": "\uf298",
    "fa-wpexplorer": "\uf2de",
    "fa-wpbeginner": "\uf297",
    "fa-wordpress-simple": "\uf411",
    "fa-wolf-pack-battalion": "\uf514",
    "fa-wodu": "\ue088",
    "fa-wizards-of-the-coast": "\uf730",
    "fa-wirsindhandwerk": "\ue2d0",
    "fa-whmcs": "\uf40d",
    "fa-weixin": "\uf1d7",
    "fa-weibo": "\uf18a",
    "fa-weebly": "\uf5cc",
    "fa-webflow": "\ue65c",
    "fa-watchman-monitoring": "\ue087",
    "fa-vuejs": "\uf41f",
    "fa-vnv": "\uf40b",
    "fa-vk": "\uf189",
    "fa-vine": "\uf1ca",
    "fa-vimeo-v": "\uf27d",
    "fa-viber": "\uf409",
    "fa-viadeo": "\uf2a9",
    "fa-viacoin": "\uf237",
    "fa-vaadin": "\uf408",
    "fa-ussunnah": "\uf407",
    "fa-usb": "\uf287",
    "fa-upwork": "\ue641",
    "fa-ups": "\uf7e0",
    "fa-untappd": "\uf405",
    "fa-unsplash": "\ue07c",
    "fa-unity": "\ue049",
    "fa-uniregistry": "\uf404",
    "fa-uncharted": "\ue084",
    "fa-umbraco": "\uf8e8",
    "fa-uikit": "\uf403",
    "fa-ubuntu": "\uf7df",
    "fa-uber": "\uf402",
    "fa-typo3": "\uf42b",
    "fa-tumblr": "\uf173",
    "fa-trello": "\uf181",
    "fa-trade-federation": "\uf513",
    "fa-threads": "\ue618",
    "fa-themeisle": "\uf2b2",
    "fa-themeco": "\uf5c6",
    "fa-the-red-yeti": "\uf69d",
    "fa-tencent-weibo": "\uf1d5",
    "fa-symfony": "\uf83d",
    "fa-swift": "\uf8e1",
    "fa-suse": "\uf7d6",
    "fa-supple": "\uf3f9",
    "fa-superpowers": "\uf2dd",
    "fa-stumbleupon-circle": "\uf1a3",
    "fa-stumbleupon": "\uf1a4",
    "fa-studiovinari": "\uf3f8",
    "fa-stubber": "\ue5c7",
    "fa-stripe-s": "\uf42a",
    "fa-strava": "\uf428",
    "fa-sticker-mule": "\uf3f7",
    "fa-steam-symbol": "\uf3f6",
    "fa-steam": "\uf1b6",
    "fa-staylinked": "\uf3f5",
    "fa-stackpath": "\uf842",
    "fa-stack-exchange": "\uf18d",
    "fa-square-xing": "\uf169",
    "fa-square-x-twitter": "\ue61a",
    "fa-square-whatsapp": "\uf40c",
    "fa-square-web-awesome-stroke": "\ue684",
    "fa-square-web-awesome": "\ue683",
    "fa-square-vimeo": "\uf194",
    "fa-square-viadeo": "\uf2aa",
    "fa-square-upwork": "\ue67c",
    "fa-square-tumblr": "\uf174",
    "fa-square-threads": "\ue619",
    "fa-square-steam": "\uf1b7",
    "fa-square-snapchat": "\uf2ad",
    "fa-square-reddit": "\uf1a2",
    "fa-square-pied-piper": "\ue01e",
    "fa-square-odnoklassniki": "\uf264",
    "fa-square-letterboxd": "\ue62e",
    "fa-square-lastfm": "\uf203",
    "fa-square-instagram": "\ue055",
    "fa-square-hacker-news": "\uf3af",
    "fa-square-google-plus": "\uf0d4",
    "fa-square-gitlab": "\ue5ae",
    "fa-square-github": "\uf092",
    "fa-square-git": "\uf1d2",
    "fa-square-font-awesome-stroke": "\uf35c",
    "fa-square-font-awesome": "\ue5ad",
    "fa-square-facebook": "\uf082",
    "fa-square-dribbble": "\uf397",
    "fa-square-behance": "\uf1b5",
    "fa-speaker-deck": "\uf83c",
    "fa-speakap": "\uf3f3",
    "fa-space-awesome": "\ue5ac",
    "fa-sourcetree": "\uf7d3",
    "fa-snapchat": "\uf2ab",
    "fa-slideshare": "\uf1e7",
    "fa-skyatlas": "\uf216",
    "fa-sketch": "\uf7c6",
    "fa-sitrox": "\ue44a",
    "fa-sith": "\uf512",
    "fa-sistrix": "\uf3ee"
}
export default unicodeData;